<template>
    <div class="bimAll">
        <div class="header">
            <el-row style="color:#a9d9ee;font-size:21px;padding-top:30px">
                <el-col :span="12" style="text-align: left">
                    <span style="margin-left:40px">{{dateYMD}}</span>
                    <span style="margin-left:25px">{{day}}</span>
                    <span style="margin-left:25px">{{dateHMS}}</span>
                </el-col>
                <el-col :span="12" style="text-align: right;">
                    <span style="margin-right:25px">上海</span>
                    <span v-if="WeatherImg=='xue'" style="margin-right:20px">
                        <img src="../../assets/weather/xue.png" class="avatarwea" alt />
                    </span>
                    <span v-else-if="WeatherImg=='lei'" style="margin-right:20px">
                        <img src="../../assets/weather/lei.png" class="avatarwea" alt />
                    </span>
                    <span v-else-if="WeatherImg=='wu'">
                        <img src="../../assets/weather/wu.png" class="avatarwea" alt />
                    </span>
                    <span v-else-if="WeatherImg=='yun'" style="margin-right:20px">
                        <img src="../../assets/weather/yun.png" class="avatarwea" alt />
                    </span>
                    <span v-else-if="WeatherImg=='yu'" style="margin-right:20px">
                        <img src="../../assets/weather/yu.png" class="avatarwea" alt />
                    </span>
                    <span v-else-if="WeatherImg=='yin'">
                        <img src="../../assets/weather/yin.png" class="avatarwea" alt />
                    </span>
                    <span v-else-if="WeatherImg=='qing'" style="margin-right:20px">
                        <img src="../../assets/weather/qing.png" class="avatarwea" alt />
                    </span>
                    <span v-else style="margin-right:20px">
                        <img src="../../assets/weather/yun.png" class="avatarwea" alt />
                    </span>
                    <span style="margin-right:10px">{{Weather}}</span>
                </el-col>
            </el-row>
        </div>
        <!-- 模型树 -->
        <div
            class="modelTreePanel panelzindex model"
            id="modelTree"
            style="position:absolute;z-index:111"
            :style="{ display: modelTreeCardDisplay == true ? 'block' : 'none' }"
        >
            <el-card class="panel-card panel-card-puls">
                <div slot="header" class="clearfix" id="modelTreeHandle">
                    <span>监控情况</span>
                </div>
                <div style="height:500px;">
                    <el-tabs v-model="jiankongTree" @tab-click="handleClick" style="color:#ffffff">
                        <el-tab-pane label="测点树" name="first">
                            <div class="TreeLeftBtn1">
                                <el-input v-model="searchPoint" />
                            </div>
                            <div class="tree-content">
                                <el-tree
                                    :data="pointTreeData"
                                    :props="props"
                                    ref="tree"
                                    default-expand-all
                                    @node-click="handleNodeClick"
                                    @check="handleCheck"
                                >
                                <div v-if="data.AlarmState == '红色警报'" slot-scope="{ node, data }" style="font-size:14px;color:#ff4848;font-weight: 600;">{{data.PointName}}</div>
                                <div v-else-if="data.AlarmState == '橙色警报'" slot-scope="{ node, data }" style="font-size:14px;color:#ff872f;font-weight: 600;">{{data.PointName}}</div>
                                <div v-else-if="data.AlarmState == '黄色警报'" slot-scope="{ node, data }" style="font-size:14px;color:#fbc033;font-weight: 600;">{{data.PointName}}</div>
                                <div v-else-if="data.AlarmState == ''" slot-scope="{ node, data }" style="font-size:14px;color:#8cc38d;font-weight: 600;">{{data.PointName}}</div>
                                <div v-else-if="data.AlarmState == 'EarlyAlert'" slot-scope="{ node, data }" style="font-size:14px;color:#fbc033;font-weight: 600;">{{data.PointName}}</div>
                                <div v-else-if="data.AlarmState == '没数据'" slot-scope="{ node, data }" style="font-size:14px;color:#c3c3c3;font-weight: 600;">{{data.PointName}}</div>
                                <div v-else-if="data.AlarmState == '无'" slot-scope="{ node, data }" style="font-size:14px;color:#c3c3c3;font-weight: 600;">{{data.PointName}}</div>
                                <div v-else slot-scope="{ node, data }" style="font-size:14px;font-weight: 600;">{{data.PointName}}</div>
                                </el-tree>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="模型树" name="second">
                            <div style="height:435px;" class="modeltree">
                                <el-scrollbar style="height:452px;margin-top: 10px;">
                                    <el-tree
                                        :data="modelTreeData"
                                        show-checkbox
                                        node-key="id"
                                        :filter-node-method="filterNode"
                                        ref="modelTree"
                                        :props="modelTreeProps"
                                        @node-click="treeNodeClick"
                                        @check-change="treeCheckChange"
                                        :default-checked-keys="modelTreeDefaultChecked_New"
                                    ></el-tree>
                                </el-scrollbar>
                            </div>
                        </el-tab-pane>
                        <!-- <el-tab-pane label="监控树" name="third">监控树3</el-tab-pane> -->
                    </el-tabs>
                </div>
            </el-card>
        </div>
        <!-- 剖切 -->
        <div
            class="modelTreePanel panelzindex model"
            id="sectionPanel"
            style="position:absolute;z-index:111"
            :style="{ display: sectionPanelDisplay == true ? 'block' : 'none' }"
        >
            <el-card class="panel-card panel-card-puls">
                <div slot="header" class="clearfix" id="modelTreeHandle">
                    <span>剖切</span>
                </div>
                <div style="height:500px;">
                    <el-checkbox
                        v-model="enablePouqie"
                        :disabled="!sceneLoadedCompleted"
                        @change="section('enable')"
                        style="margin-left: -171px;"
                    ></el-checkbox>
                    <span style="padding-left: 10px;">开启剖切</span>
                    <div style="margin-top:20px;padding-left:23px">
                        <el-radio
                            v-model="sectionMode"
                            :disabled="!enablePouqie"
                            @change="section('X')"
                            label="x"
                            style="margin-right:20px"
                        >X</el-radio>
                        <el-radio
                            v-model="sectionMode"
                            :disabled="!enablePouqie"
                            @change="section('Y')"
                            label="y"
                            style="margin-right:20px"
                        >Y</el-radio>
                        <el-radio
                            v-model="sectionMode"
                            :disabled="!enablePouqie"
                            @change="section('Z')"
                            label="z"
                            style="margin-right:20px"
                        >Z</el-radio>
                        <el-radio
                            v-model="sectionMode"
                            :disabled="!enablePouqie"
                            @change="section('Box')"
                            label="Box"
                            style="margin-right:20px"
                        >Box</el-radio>
                    </div>
                </div>
            </el-card>
        </div>
        <!-- 测量 -->
        <div
            class="modelTreePanel panelzindex model"
            id="measurePanel"
            style="position:absolute;z-index:111"
            :style="{ display: measurePanelDisplay == true ? 'block' : 'none' }"
        >
            <el-card class="panel-card panel-card-puls">
                <div slot="header" class="clearfix" id="modelTreeHandle">
                    <span>测量</span>
                </div>
                <div style="height:500px;">
                    <div>
                        <el-checkbox
                            v-model="enableMeasure"
                            :disabled="!sceneLoadedCompleted"
                            @change="measureEnabled()"
                            style="margin-left: -171px;"
                        ></el-checkbox>
                        <span style="padding-left:10px">测量模式</span>
                        <a @click="resetMeasure()">
                            <i
                                class="fa fa-trash-o fa-1x"
                                title="删除选中"
                                style="cursor:pointer;padding-left:30px"
                            ></i>
                        </a>
                    </div>
                    <div style="margin-top:16px;padding-left:23px">
                        <el-row style="color:#fff;">
                            <el-col :span="6">
                                <el-radio
                                    v-model="measureType"
                                    :disabled="!enableMeasure"
                                    label="distance"
                                    @change="measure()"
                                >距离</el-radio>
                            </el-col>
                            <el-col :span="6">
                                <el-radio
                                    v-model="measureType"
                                    :disabled="!enableMeasure"
                                    label="angle"
                                    @change="measure()"
                                >角度</el-radio>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-card>
        </div>
        <!-- 属性 -->
        <div
            class="modelTreePanel panelzindex model modelproperty"
            id="propertyPanel"
            style="position:absolute;z-index:111"
            :style="{ display: propertyPanelDisplay == true ? 'block' : 'none'}"
        >
            <el-card class="panel-card panel-card-puls">
                <div slot="header" class="clearfix" id="modelTreeHandle">
                    <span>属性</span>
                </div>
                <div style="height:500px;overflow: auto;">
                  <div v-if="elementProperties.length>0" class="propertyTitle">测点属性</div>
                  <div style="margin-bottom:10px" v-if="elementProperties.length>0" >
                     <el-table
                         :data="elementProperties"
                         border
                         :show-header="false"
                         row-class-name="rable-row"
                         cell-class-name="table-cell"
                         style="background-color:#24253b;color:#fff"
                     >
                         <el-table-column label="名称" prop="Key"></el-table-column>
                         <el-table-column label="值" prop="Value"></el-table-column>
                    </el-table>
                  </div>
                  <div v-if="modelProperties.length>0" class="propertyTitle">模型属性</div>
                  <div style="overflow: auto;" v-if="modelProperties.length>0">
                     <el-table
                         :data="modelProperties"
                         border
                         :show-header="false"
                         row-class-name="rable-row"
                         cell-class-name="table-cell"
                         style="background-color:#24253b;color:#fff"
                     >
                         <el-table-column label="名称" prop="Key"></el-table-column>
                         <el-table-column label="值" prop="Value"></el-table-column>
                    </el-table>
                  </div>
                </div>
            </el-card>
        </div>

        <div id="viewport" style="display:block"></div>
        <div style="position: absolute;bottom:10px;width:96%;z-index:3;">
        <div id="toolbar" class="toolbars" style="z-index:1">
            <el-button
                type="primary"
                title="构件树"
                @click="toolBarBtnClick('ModelTree')"
                circle
                class="sbim-icon-structure"
                style="width:40px;height:40px"
            />
            <el-button
                type="primary"
                title="剖切"
                @click="toolBarBtnClick('SectionSetting')"
                circle
                class="sbim-icon-section-analysis"
                style="width:40px;height:40px"
            />
            <el-button
                type="primary"
                title="测量"
                @click="toolBarBtnClick('MeasurePanel')"
                circle
                class="sbim-icon-measure"
                style="width:40px;height:40px"
            />
            <el-button
                type="primary"
                title="属性"
                @click="toolBarBtnClick('PropertyPanel')"
                circle
                class="sbim-icon-properties"
                style="width:40px;height:40px"
            />
            <el-button
                type="primary"
                title="监测报表"
                @click="GetProjectDailys()"
                circle
                style="width:40px;height:40px;padding-bottom: 9px;"
            ><i class="el-icon-document" style="font-size:16px"/></el-button>
            <el-button
                type="primary"
                title="报警测点详情"
                @click="rankDialog()"
                circle
                style="width:40px;height:40px;padding-bottom: 9px;"
            ><i class="el-icon-s-unfold" style="font-size:16px"/></el-button>
            <el-button
                type="primary"
                title="是否启动监测构件周围测点功能"
                @click="openPoint()"
                circle
                style="width:40px;height:40px;padding-bottom: 9px;"
            ><i class="el-icon-turn-off" style="font-size:16px"/></el-button>
        </div>
        <div class="heightCharStyle" style="z-index:1;bottom: 10px;">
            <div class="heightChartop">
                <span>数据统计</span>
            </div>
            <div class="heightCharleft">
                <div style="float:right">
                    <el-date-picker
                      v-model="AlarmCountDate"
                      :picker-options="pickerOptions"
                      :clearable="false"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="timeChangeLeft">
                    </el-date-picker>
                  <!-- <el-button type="primery" class="cssHasL activeBnt" id="left1" @click="leftTable(1,'本周')">本周</el-button> -->
                  <el-button class="cssHasL" id="left2" @click="leftTable(2,'本月')">本月</el-button>
                  <el-button class="cssHasL" id="left3" @click="leftTable(3,'本年')">本年</el-button>
                  <el-button style="display:none" class="cssHasL" id="left3" @click="leftTable(4,'筛选')">筛选</el-button>
                </div>
                <div>
                    <div id="pro1container" style="min-width:760px;height:174px"></div>
                </div>
            </div>
            <div class="heightCharright">
              <div style="text-align: right;">
                    <el-date-picker
                      v-model="AlarmRankDate"
                      :picker-options="countPickerOptions"
                      :clearable="false"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="timeChangeRight">
                    </el-date-picker>
                <el-button class="cssHasR" id="right1" @click="rightTable(1,'本周')">本周</el-button>
                <el-button class="cssHasR activeBnt" id="right2" @click="rightTable(2,'本月')">本月</el-button>
                <el-button class="cssHasR" id="right3" @click="rightTable(3,'本年')">本年</el-button>
                <el-button style="display:none" class="cssHasR" id="right3" @click="rightTable(4,'筛选')">筛选</el-button>
              </div>
              <div>
                  <div id="container" style="max-width:1000px;height:174px"></div>
              </div>
            </div>
        </div>
        </div>
        <el-dialog :visible="ProjectDailys" @close="closeDailys()">
            <div style="margin-bottom:10px">
                <el-row>
                    <el-col :span="10">
                        <el-date-picker
                          v-model="dailysTime"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                        </el-date-picker></el-col>
                    <el-col :span="3">
                        <el-button type="primary" plain @click="serchdailys">查询</el-button>
                    </el-col>
                </el-row>
            </div>
            
            <el-table
              id="out-table"
              ref="singleTable"
              stripe
              :data="DailysList"
              highlight-current-row
              style="width:100%;"
              border
            >
               <el-table-column align="left" label="文件名">
                <template slot-scope="scope">{{ scope.row.FileName }}</template>
              </el-table-column>
              <el-table-column align="left" label="时间" prop="UploadDate" width="200" sortable>
                <template slot-scope="scope">{{ scope.row.UploadDate }}</template>
              </el-table-column>
              <el-table-column label="操作" width="70">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="downLoadFile(scope.row)">下载</el-button>
                </template>
              </el-table-column>
            </el-table>
            <component
                :is="PaginationComponent"
                :options="options"
                @getPagingResult="getPagingResult"
                ref="pagination"
            ></component>
        </el-dialog>
        <!-- 侧斜孔 -->
        <el-dialog :visible="ProjectHole" @open="open()" @close="closeHole">
            <div id="containerHole" style="width:800px;height:600px"></div>
        </el-dialog>
        <el-dialog :visible="ProjectAlarm" @close="closeAlarm" class="rankClass">
            <div class="rankDialogClass">
                日期：<span style="margin-right:50px;color:#409EFF" v-if="optionsCount.serviceData[0]">{{optionsCount.serviceData[0].MonitorDate}}</span> 
                总次数：<span style="margin-right:30px;color:#409EFF">{{optionsCount.serviceData.length}} </span>
                红色报警次数：<span style="margin-right:30px;color:#ff4848">{{optionsCount.serviceData.filter(n=>n.AlarmRank=="红色报警").length}} </span>
                橙色报警次数：<span style="margin-right:30px;color:#ff872f">{{optionsCount.serviceData.filter(n=>n.AlarmRank=="橙色报警").length}} </span>
                黄色报警次数：<span style="margin-right:30px;color:#fbc033">{{optionsCount.serviceData.filter(n=>n.AlarmRank=="黄色报警").length}} </span>
            </div>
            <el-table
                :header-cell-style="{background:'#eef1f6',color:'#606266'}"
                :data="alertCountTable"
                border
                row-class-name="rable-row"
                cell-class-name="table-cell"
                style="height:">
                <el-table-column label="序号" width="80px" type="index" align="center">
                </el-table-column>
                <el-table-column label="测项名称">
                    <template slot-scope="scope">{{scope.row.PrjName}}</template>
                </el-table-column>
                <el-table-column label="监测次数" width="100px">
                    <template slot-scope="scope">{{scope.row.MonitorTime}}</template>
                </el-table-column>
                <el-table-column label="监测日期">
                    <template slot-scope="scope">{{scope.row.MonitorDate}}</template>
                </el-table-column>
                <el-table-column label="测点名称"  width="130px">
                    <template slot-scope="scope">{{scope.row.PointName}}</template>
                </el-table-column>
                <el-table-column label="测点类型">
                    <template slot-scope="scope">{{scope.row.PointType}}</template>
                </el-table-column>
                <el-table-column label="累计变化量" width="100px">
                    <template slot-scope="scope">{{scope.row.TotalVariance}}</template>
                </el-table-column>
                <el-table-column label="本次变化量" width="100px">
                    <template slot-scope="scope">{{scope.row.CurrentVariance}}</template>
                </el-table-column>
                <el-table-column label="变化速率" width="100px">
                    <template slot-scope="scope">{{scope.row.DailyVariance}}</template>
                </el-table-column>
                <el-table-column label="报警类型" width="100px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.AlarmRank == '红色报警'" style="color:#ff4848">{{scope.row.AlarmRank}}</span>
                        <span v-else-if="scope.row.AlarmRank == '橙色报警'" style="color:#ff872f">{{scope.row.AlarmRank}}</span>
                        <span v-else-if="scope.row.AlarmRank == '黄色报警'" style="color:#fbc033">{{scope.row.AlarmRank}}</span>
                        <span v-else>{{scope.row.AlarmRank}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <component
                :is="PaginationComponentCount"
                :options="optionsCount"
                @getPagingResult="getPagingResultCount"
                ref="pagination"
            ></component>
        </el-dialog>
        <!-- 点击构件之后的插值统计图 -->
        <el-dialog :visible="pointInterpolation" @close="colsePoint" :close-on-click-modal="false" class="interClass heightCharDialog">
            <el-row>
                <el-col :span="8">
                    <el-select v-model="showInterDetail" placeholder="请选择" @change="clickZuName(showInterDetail)">
                      <el-option
                        v-for="item in zuList"
                        :key="item.value"
                        :label="item.zuName"
                        :value="item.zuName"
                        >
                      </el-option>
                    </el-select>
                </el-col>
                <el-col :span="8">
                    <el-row style="font-size:16px">
                        <el-col :span="11" style="text-align:right">
                            <span v-for="(arr,index) in pointarr" :key = "'arr1'+index">
                                <span v-if="index ==1">左侧测点：<span v-if="arr">{{arr.MarkID}}</span><span v-else>暂无</span></span>
                            </span>
                        </el-col>
                        <el-col :span="11" style="padding-left:10px">
                            <span v-for="(arr,index) in pointarr" :key = "'arr1'+index">
                                <span v-if="index ==2">右侧测点：<span v-if="arr">{{arr.MarkID}}</span><span v-else>暂无</span></span>
                            </span>
                        </el-col>
                    </el-row>
                </el-col> 
                <el-col :span="8">
                    <div style="text-align: right;">
                    <el-date-picker
                      v-model="interDate"
                      :picker-options="countPickerOptions"
                      :clearable="false"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="timeChangeInter">
                    </el-date-picker>
                <el-button class="cssHasD activeBntInter" id="inter2" @click="interTable(2,'本月')">本月</el-button>
                <el-button class="cssHasD" id="inter3" @click="interTable(3,'本年')">本年</el-button>
                <el-button style="display:none" class="cssHasD" id="inter4" @click="interTable(4,'筛选')">筛选</el-button>
                </div>
                </el-col>
            </el-row>            
                <div id="containerInterpolation" style="width:1400px;height:600px"></div>
        </el-dialog>
        <div v-show="pointMessageBox==true" role="alert" class="el-message el-message--warning" style="top: 20px; z-index: 2076;">
            <i class="el-message__icon el-icon-warning"></i>
            <p class="el-message__content">已启动监测构件周围测点功能</p>
        </div>
    </div>
</template>
<script>
import Highcharts from "highcharts/highstock";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsDrilldown from "highcharts/modules/drilldown";
import Highcharts3D from "highcharts/highcharts-3d";
var modelList = [];
var bimEngine = null;
var markers = [];
var cdmodels = [];
var cdFromServer = {};
var AlarmStatePoint = [];
var cdHtmlMarters = {};
var htmlcdmarker = null;
var chart1;
var chart2;
var chart3;
var chart4;

var dlqModel = null;
var dlqModelDbids = null;

HighchartsMore(Highcharts);
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
export default {
    data() {
        return {
            modelTreeData1:[
                {
                    id:1
                },{
                    id:2
                },{
                    id:3
                }

            ],
            zuList:[],
            pickerOptions: {
               disabledDate: time => {
                   return (
                       time < new Date("1990-01-01") ||
                       time > new Date("2220-12-31")
                   )
               }
           },
           countPickerOptions: {
               disabledDate: time => {
                   return (
                       time < new Date("1990-01-01") ||
                       time > new Date("2220-12-31")
                   )
               }
           },
            showInterDetail:"",//选择框的值
            pointMessageBox:false, //顶部监测构件周围测点功能显隐
            pointInterpolation:false,//插值统计图弹出框
            mapListfitCds:[],//构件组的map集合
            pointarr:[],//测点
            currentInterDate:[],
            alertCountTable:[],
            pointNameTime:'',
            pointNameTimeTemp:'',
            ProjectHole:false,
            ProjectAlarm:false,
            PaginationComponent: Object,
            PaginationComponentCount: Object,
            ProjectDailys:false,
            DailysList:[],
            DailysListTemp:[],
            dailysTime:'',
            modelTreeCardDisplay: true,
            sectionPanelDisplay: false,
            measurePanelDisplay: false,
            propertyPanelDisplay: false,
            sectionMode: "y",
            enablePouqie: false,
            sceneLoadedCompleted: false,
            enableMeasure: false,
            measureType: "distance",
            searchPoint: "",
            elementProperties: [],
            modelTreeData: [],
            pointTreeData: [],
            pointTreeDataSearch: [],
            modelPoint: "地下管道模型",
            modelProperties: [],
            modelTreeDefaultChecked: [],    
            modelTreeDefaultChecked_New:[],        
            jiankongTree: "first",
            dateYMD: "",
            dateHMS: "",
            PropertyTitle: "",
            Weather: "",
            WeatherImg: "",
            wea: "",
            day: "",
            options: {
              param: {
                serachText: ""
              },
              servicePage: false,
              serachField: ["UserName","Action"], // 需要搜索的字段数组
              serviceData: [],
            },
            optionsCount: {
              param: {
                serachText: ""
              },
              servicePage: false,
              serachField: [],  //需要搜索的字段数组
              serviceData: [],
            },
            props: {
                label: "PointName",
                children: "Points",
            },
            modelTreeProps: {
                children: "children",
                label: "label",
            },
            showP:false, //判断测点信息从侧点树点击进来
            leftBtnStu:"本月",
            rightBtnStu:"本月",
            interBtnStu:"本月",
            AlarmCountDate: this.timeofMmonth(),
            AlarmRankDate: this.timeofMmonth(),
            interDate: this.timeofMmonth(),

            //报警级别按时间统计
            PointAlarmRank:{
                week:[],
                month:[],
                year:[],
                customFilter:[],//自定义时间筛选的数据
                yearhData:{
                    CurrentVariance:[],
                    TotalVariance:[],
                    DailyVariance:[],
                    TotalAlertUpLimit:[],
                    TotalAlertLowerLimit:[]
                },
                monthData:{
                    CurrentVariance:[],
                    TotalVariance:[],
                    DailyVariance:[],
                    TotalAlertUpLimit:[],
                    TotalAlertLowerLimit:[]
                },
                weekData:{
                    CurrentVariance:[],
                    TotalVariance:[],
                    DailyVariance:[],
                    TotalAlertUpLimit:[],
                    TotalAlertLowerLimit:[]
                },
                customFilterData:{
                    CurrentVariance:[],
                    TotalVariance:[],
                    DailyVariance:[],
                    TotalAlertUpLimit:[],
                    TotalAlertLowerLimit:[]
                }

            },
            PointAlarmRankList:[], //所有的报警级别按时间统计数据
            //报警级别按数量统计
            PointAlarmCount:{
                week:["星期一","星期二","星期三","星期四","星期五","星期六", "星期日"],
                month:[],
                year:[],
                monitorTime:[],
                customFilter:[],
                yearhData:{
                    redAlarm:[],
                    orangeAlarm:[],
                    yellowAlarm:[],
                    yearMonitorTime:[],
                },
                monthData:{
                    redAlarm:[],
                    orangeAlarm:[],
                    yellowAlarm:[],
                    monthMonitorTime:[],
                },
                weekData:{
                    redAlarm:[],
                    orangeAlarm:[],
                    yellowAlarm:[],
                    weekMonitorTime:[],
                },
                customFilterData:{
                    redAlarm:[],
                    orangeAlarm:[],
                    yellowAlarm:[],
                    customFilterMonitorTime:[],
                }
            },
            //所有的测点插值数据
            interDataList:{
                week:[],
                month:[],
                year:[],
                customFilter:[],//自定义时间筛选的数据
                yearhData:{
                    CurrentVariance:[],
                    TotalVariance:[],
                    DailyVariance:[]
                },
                monthData:{
                    CurrentVariance:[],
                    TotalVariance:[],
                    DailyVariance:[]
                },
                weekData:{
                    CurrentVariance:[],
                    TotalVariance:[],
                    DailyVariance:[]
                },
                customFilterData:{
                    CurrentVariance:[],
                    TotalVariance:[],
                    DailyVariance:[]
                }
            },
            PointAlarmCountList:[], //所有的监控数据
            intertList:{   //所有的测点插值数据
                gro1:{
                    p0:[],
                    p1:[],
                    p2:[],
                    p3:[]
                }
            } 
        };
    },
    watch: {
        searchPoint: function (newVal, oldVal) {
            var searchPoint = newVal;
            if (searchPoint != "") {
                this.pointTreeData = []
                for(var i=0;i<this.pointTreeDataSearch.length;i++){
                    var pointItemList = this.pointTreeDataSearch[i].Points.filter((n) => {
                        return n.PointName.toUpperCase().indexOf(searchPoint.toUpperCase()) >= 0;
                    });
                    this.pointTreeData = this.pointTreeData.concat(pointItemList)
                }
                this.pointTreeData = this.sortId(this.pointTreeData,'PointName')
            } else {
                this.pointTreeData = this.pointTreeDataSearch;
            }
        },
    },
    created() {
        // this.WeatherInfo();
        this.timeofMmonth();
    },
    mounted() {
        // 每次进来时判断一下，是否是登陆页面进来的。
        var userName = localStorage.getItem("userName");
        if (userName != "bimjkjc") {
            this.$message.error("请先登录");
            this.$router.push('/login');
        }
        // 是登陆页面进来的，删除这个localstorage,下次还是从登陆页面进来。
        localStorage.removeItem("userName");

        let _this = this; // 声明一个变量指向Vue实例this，保证作用域一致
        window.modelLable = function(PointName){
            console.log(PointName[0].toUpperCase)
            if(PointName[0].toUpperCase()=="P" || PointName[0].toUpperCase()=="T"){
                 _this.ProjectHole = true
                 _this.projectHoleHeighcharts(PointName);
            }             
        },
        // this.getcdModels();
        this.initBimEngine();
        this.modelData();
        this.GetProjectSummaryByDate();
        this.showHighcharts();        
        
        this.timer = setInterval(() => {
            var date = new Date();
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            var d = date.getDate();
            d = d < 10 ? "0" + d : d;
            var h = date.getHours();
            h = h < 10 ? "0" + h : h;
            var minute = date.getMinutes();
            minute = minute < 10 ? "0" + minute : minute;
            var second = date.getSeconds();
            second = second < 10 ? "0" + second : second;
            var day = date.getDay();
            _this.dateYMD = y + "年" + m + "月" + d + "日";
            _this.dateHMS = h + ":" + minute + ":" + second;
            switch (day) {
                case 1:
                    _this.day = "星期一";
                    break;
                case 2:
                    _this.day = "星期二";
                    break;
                case 3:
                    _this.day = "星期三";
                    break;
                case 4:
                    _this.day = "星期四";
                    break;
                case 5:
                    _this.day = "星期五";
                    break;
                case 6:
                    _this.day = "星期六";
                    break;
                case 0:
                    _this.day = "星期日";
                    break;
            }
            // _this.date = new Date(); // 修改数据date
        }, 1000);
    },
    methods: {
        initBimEngine() {
            var that = this;
            modelList = [];
            var config = {
                from_server: true,
                https: false,
                ip: "47.117.40.56",
                port: "6013",
                userKey: "78f78e5e-b710-49f3-9153-05be66dc63c0",
                projectId: "05246873-a209-4aa4-8efa-36cf00d06580",
                //projectId: "f4377369-cabe-4c8f-af02-f5380f159774",
                domId: "viewport",
            };
            var sv = Smart.Viewing;
            var svp = Smart.Viewing.Private;
            var options = {
                config3d: {
                    extensions: [
                        // "Smart.Fusion360.Animation",
                        // "Smart.Viewing.MarkupsCore",
                        // "Smart.Viewing.MarkupsGui",
                        "Smart.ViewCubeUi",
                        "Smart.Section",
                        "Smart.Measure"
                    ],
                    useCssBackground: true,
                    useConsolidation: true,
                    consolidationMemoryLimit: 256 * 1024 * 1024, // 256MB - Optional, defaults to 100MB
                },
                applyRefPoint:true,
                isAEC: true,
                applyScaling: { to: "m" },
                useConsolidation: true,
                documentId: "",
                consolidationMemoryLimit: 256 * 1024 * 1024, // 256MB - Optional, defaults to 100MB
            };
            var viewerElement = document.getElementById(config.domId);
            options = Object.assign(options, config);
            bimEngine = new sv.Viewer3D(viewerElement, options.config3d);
            window.bimEngine = bimEngine;
            Smart.Viewing.Initializer(options, function (data) {
                if (data[0].data.length === 0) {
                    alert("没有找到轻量化模型数据！");
                    return;
                }
                data[0].data.forEach((element) => {
                    modelList.push({
                        urn: element.ModelView[0].LoadUrl,
                        fileName: element.ModelName,
                        idExtenalMapping: {},
                        modelID: -1,
                        modelObj: null,
                        x: 0,
                        y: 0,
                        z: 0,
                    });
                });
               
                var _m = modelList.find(n=>n.fileName == modelConfig[0].modelName);
                bimEngine.start(_m.urn,Object.assign(options,{globalOffset:modelConfig[0].globalOffset}) , (m) => {
                    if (modelConfig[0].needStore) {
                        dlqModel = m;
                    }
                    _m.modelObj = m;
                    _m.modelID = m.id;
                    m.getExternalIdMapping((n) => {
                        _m.idExtenalMapping = n;
                    });
                });

                for (let i = 1; i < modelConfig.length; i++) {
                    (function (i) {
                        let __m = modelList.find(n=>n.fileName == modelConfig[i].modelName);
                        bimEngine.loadModel(__m.urn, Object.assign(options,{globalOffset:modelConfig[i].globalOffset}), (m) => {
                                if (modelConfig[i].needStore) {
                                    dlqModel = m;
                                }
                                __m.modelObj = m;
                                __m.modelID = m.id;
                                m.getExternalIdMapping((n) => {
                                    __m.idExtenalMapping = n;
                                });
                        });
                    })(i);
                    
                }
            });
            bimEngine.loadExtension("Smart.HTMLMarker");
            this.bimEngineCallBack();
        },
        getPagingResult(result) {
          this.DailysList = result 
        //   this.$refs.singleTable.setCurrentRow(this.LogList[0]); // 默认选中第一行
        },
        getPagingResultCount(result){            
          this.alertCountTable = result 
        },
        //获取本月时间赋值筛选框
        timeofMmonth(){
            var monthDate = [];
            var now = new Date(); //当前日期
            var nowMonth = now.getMonth(); //当前月
            var nowYear = now.getFullYear(); //当前年
            //本月的开始时间
            var monthStartDate = new Date(nowYear, nowMonth, 1);
            var yy = monthStartDate.getFullYear() + "-";
            var mm =
              (monthStartDate.getMonth() + 1 < 10
                ? "0" + (monthStartDate.getMonth() + 1)
                : monthStartDate.getMonth() + 1) + "-";
            var dd =
              monthStartDate.getDate() < 10
                ? "0" + monthStartDate.getDate()
                : monthStartDate.getDate();
            //本月的结束时间
            var monthEndDate = new Date(nowYear, nowMonth + 1, 0);
            var YY = monthEndDate.getFullYear() + "-";
            var MM =
              (monthEndDate.getMonth() + 1 < 10
                ? "0" + (monthEndDate.getMonth() + 1)
                : monthEndDate.getMonth() + 1) + "-";
            var DD =
              monthEndDate.getDate() < 10
                ? "0" + monthEndDate.getDate()
                : monthEndDate.getDate();
            monthDate[0] = yy + mm + dd;
            monthDate[1] = YY + MM + DD;
            return monthDate
        },

        timeofweek(){
            let now = new Date(), //当前日期
　　             nowDayOfWeek = now.getDay(), //今天本周的第几天
　　             nowDay = now.getDate(), //当前日
　　             nowMonth = now.getMonth(), //当前月
　　             nowYear = now.getFullYear() //当前年
            var startDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1)
　　　　     var endDate = new Date(nowYear, nowMonth, nowDay + 7 - nowDayOfWeek)
            return [startDate,endDate]
        },
        //获取本月时间段
        timeofM(){            
            var monthDate = []
            var date = new Date()
            var month = date.getMonth()
            var newday = date.setDate(1)  // 设置当前时间为这个月一号
            var nowMonthTime = date.getTime()   // 获取这个月的一号的时间戳
            var nextMonth = date.setMonth(month + 1)  // 设置当前时间为下个月一号
            var nextMonthTime = date.getTime()  // 获取下个月的一号的时间戳
            var countDays = (nextMonthTime - nowMonthTime)/24/60/60/1000 // 返回这个月的天数
            var lastDayDate  = new Date((new Date()).setDate(countDays))  // 返回这个月的最后一天的日期
            monthDate[0] = nowMonthTime
            monthDate[1] = lastDayDate
            return monthDate
        },
        //获取本年时间段
        timeofYear(){
            var yearDate = []
            var now = new Date(); //当前日期
            var nowYear = now.getFullYear(); //当前年
            yearDate[0] = new Date(nowYear + "-01" + "-01");
            yearDate[1] = new Date(nowYear + "-12" + "-31");
            return yearDate
        },
        //通过日期获获取警报数据
        GetProjectSummaryByDate(){
            this.$axios({
                method: "get",
                url: "External/GetProjectSummaryByDate?startDT=1990-01-01&endDT=2220-01-01",
                headers: {
                    rediscachekey: "@updateddaily",
                },
            }).then((res) => {
                res = this.sortId(res,"MonitorDate")
                this.PointAlarmCountList = res
                var date = new Date();
                var yearNow = date.getFullYear();
                var monthNow = date.getMonth() + 1;
                var dayNow = date.getDate();
                var weekNow = date.getDay();

                date.setDate(1);
                var weekNowNum = date.getDay();//获取某月1号是星期几（0-6）
                var nowDayOfWeekNum = Math.ceil((dayNow -(7-(weekNowNum==0?6:weekNowNum)))/7)//今天日期是第几周

                if (monthNow < 10) {monthNow = "0" + monthNow;}
                if (dayNow < 10) {dayNow = "0" + dayNow;}


                //当前年份的数据
                var sortDateYear = res.filter(n =>{
                    return n.MonitorDate.indexOf(yearNow+"年") != -1; 
                    // return n.MonitorDate.indexOf("2019年") != -1;
                })
                //当前月份的数据
                var sortDateMonth = sortDateYear.filter(n =>{
                    return n.MonitorDate.indexOf(monthNow+"月") != -1;
                    // return n.MonitorDate.indexOf("11月") != -1;
                })

                for(var r=0;r<sortDateYear.length;r++){
                    this.PointAlarmCount.year.push(sortDateYear[r].MonitorDate.substr(0,10))
                    this.PointAlarmCount.yearhData.yearMonitorTime.push(sortDateYear[r].MonitorTime)
                    //红色报警数量
                    var redCount = sortDateYear[r].AlarmCount.filter(r =>{
                        return r.AlarmRank == "红色报警"
                    })
                    if(redCount.length>0){
                        this.PointAlarmCount.yearhData.redAlarm.push(redCount[0].Count)
                    }else{
                        this.PointAlarmCount.yearhData.redAlarm.push(0)
                    }
                    //橙色报警数量
                    var orangeCount = sortDateYear[r].AlarmCount.filter(r =>{
                        return r.AlarmRank == "橙色报警"
                    })
                    if(orangeCount.length>0){
                        this.PointAlarmCount.yearhData.orangeAlarm.push(orangeCount[0].Count)
                    }else{
                        this.PointAlarmCount.yearhData.orangeAlarm.push(0)
                    }
                    //黄色报警数量
                    var yellowCount = sortDateYear[r].AlarmCount.filter(r =>{
                        return r.AlarmRank == "黄色报警"
                    })
                    if(yellowCount.length>0){
                        this.PointAlarmCount.yearhData.yellowAlarm.push(yellowCount[0].Count)
                    }else{
                        this.PointAlarmCount.yearhData.yellowAlarm.push(0)
                    }
                }  
                //月数据
                for(var m=0;m<sortDateMonth.length;m++){  
                    this.PointAlarmCount.month.push(sortDateMonth[m].MonitorDate.substr(8,3))
                    this.PointAlarmCount.monthData.monthMonitorTime.push(sortDateMonth[m].MonitorTime)
                    //红色报警数量
                    var redCount = sortDateMonth[m].AlarmCount.filter(r =>{
                        return r.AlarmRank == "红色报警"
                    })
                    if(redCount.length>0){
                        this.PointAlarmCount.monthData.redAlarm.push(redCount[0].Count)
                    }else{
                        this.PointAlarmCount.monthData.redAlarm.push(0)
                    }
                    //橙色报警数量
                    var orangeCount = sortDateMonth[m].AlarmCount.filter(r =>{
                        return r.AlarmRank == "橙色报警"
                    })
                    if(orangeCount.length>0){
                        this.PointAlarmCount.monthData.orangeAlarm.push(orangeCount[0].Count)
                    }else{
                        this.PointAlarmCount.monthData.orangeAlarm.push(0)
                    }
                    //黄色报警数量
                    var yellowCount = sortDateMonth[m].AlarmCount.filter(r =>{
                        return r.AlarmRank == "黄色报警"
                    })
                    if(yellowCount.length>0){
                        this.PointAlarmCount.monthData.yellowAlarm.push(yellowCount[0].Count)
                    }else{
                        this.PointAlarmCount.monthData.yellowAlarm.push(0)
                    }
                }
                this.leftTable(2,"本月");
            })
        },
        modelData() {
            this.$axios({
                method: "get",
                url: "External/GetProjectAndPoints",
                headers: {
                    rediscachekey: "GetProjectAndPoints",
                },
            }).then((res) => {
                for(var i= 0;i<res.length;i++){
                    res[i].AlarmState = "初始"
                    res[i].PointName = res[i].ProjectName
                    //组里的视点
                    for(var p= 0;p<res[i].Points.length;p++){
                        res[i].Points[p].AlarmState = "初始"
                    }
                    res[i].Points = this.sortId(res[i].Points,'PointName')       //按名称排序             
                }
                this.$axios({ 
                    method: "get", 
                    url: "External/GetProjectPointStatus",
                    headers: {
                        rediscachekey: "AlarmState",
                    }
                }).then((alarm) =>{
                    AlarmStatePoint = alarm
                    //循环测点树信息，将报警信息加入到测点里   （res为报警的测点信息）
                    for(var i= 0;i<res.length;i++){
                        for(var j= 0;j<res[i].Points.length;j++){
                            // res[i].Points[j].AlarmState = alarm.filter(n=> n.PntID == res[i].Points[j].PointID)[0].AlarmState;
                            var firstList=alarm.filter(n=> n.PntID == res[i].Points[j].PointID)[0]
                            if(firstList){
                                res[i].Points[j].AlarmState = firstList.AlarmState;
                            }
                        }
                    }
                    // 存储一下所有的测点。
                    res.forEach(element => {
                        element.Points.forEach(point => {
                            var name = point.PointName.substr(0,point.PointName.indexOf('('));
                            cdFromServer[name] = {
                                Point:point,
                                Type:element.PointName,
                                ProjectName:element.ProjectName
                            }
                        });
                    });
                    this.pointTreeData = res;
                    this.pointTreeDataSearch = res;
                })


            });
            this.$axios({
                method: "get",
                url: "External/GetProjectDailys",
                headers: {
                    rediscachekey: "@updateddaily",
                },
            }).then((res) => {
                res = this.sortData(res,"UploadDate")
                this.options.serviceData = res;
                // this.DailysList = res
                this.DailysListTemp = res // 用于条件筛选时，无污染原始完整数据
                this.PaginationComponent = () =>
                    import("@/components/PaginationAsync"); 
                })
        },
        sortId(array,key){
            return array.sort(function(a,b){
                var x = a[key];
                var y = b[key];
                return((x<y)?-1:((x>y)?1:0));
            })
        },
        sortData(array,key){
            return array.sort(function(a,b){
                var x = a[key];
                var y = b[key];
                return((x>y)?-1:((x<y)?1:0));
            })
        },
        getLastCDSattus(){

            //   this.$axios
            //     .all([
            //         this.$axios({ method: "get", url: "External/GetProjectPointStatus",headers: {rediscachekey: "AlarmState",}}),
            //         fetch("/data/cd.json", { method: "GET" }).then(res=>res.json())
            //     ])
            //     this.$axios.spread( (res, cd)=>{
            fetch("/data/cd.json").then(cd=>{
                return cd.json()
                }).then(cd=>{ 
                        var res = AlarmStatePoint 
                        cdmodels = cd;                
                        var cdTemp = []
                        res = res.filter(c=> {
                            return c.AlarmState == "红色报警" || c.AlarmState == "橙色报警" ||c.AlarmState == "黄色报警"||c.AlarmState == "没数据";
                        })
                        for(var r=0;r<res.length;r++){
                            var index = cd.findIndex(cdInfo=> cdInfo.MarkID == res[r].PntCode)
                            if( index!= -1){
                                cdTemp.push(cd[index])
                            }
                        }
                        modelList.forEach((e) => {
                            if (Object.keys(e.idExtenalMapping).length > 0) {
                                cdTemp.forEach((m) => {
                                    var  state = "";                   
                                    var f = AlarmStatePoint.filter(e=>{
                                        return e.PntCode == m.MarkID
                                    })
                                    if (f.length > 0) {
                                        state = f[0].AlarmState
                                    }        
                                    if (
                                        e.idExtenalMapping.hasOwnProperty(
                                            m.UniqueId
                                        )
                                    ) {
                                        let dbid = e.idExtenalMapping[m.UniqueId];
                                        let model = e.modelObj;
                                        let code = m.MarkID;
                                        this.createCdHTMLMarkerContent(
                                            dbid,
                                            model,
                                            code,
                                            state
                                        );
                                    }
                                });
                                cdmodels.forEach(element=>{
                                    if (e.idExtenalMapping.hasOwnProperty(element.UniqueId)) {
                                        element.dbid = e.idExtenalMapping[element.UniqueId];
                                        element.model = e.modelObj;
                                        // 计算物体的位置
                                        let tmpbox3 = new Float32Array(6);
                                        element.model.getData().instanceTree.getNodeBox(element.dbid, tmpbox3);
                                        let x = (tmpbox3[0] + tmpbox3[3]) / 2;
                                        let y = (tmpbox3[1] + tmpbox3[4]) / 2;
                                        let z = (tmpbox3[2] + tmpbox3[5]) / 2;
                                        element.position = new THREE.Vector3(x, y, z);
                                    }
                                })
                            } else {
                                e.modelObj.getExternalIdMapping((n) => {
                                    cdTemp.forEach((m) => {
                                        var  state = "";                   
                                        var f = AlarmStatePoint.filter(e=>{
                                            return e.PntCode == m.MarkID
                                        })
                                        if (f.length > 0) {
                                            state = f[0].AlarmState
                                        }
                                        if (n.hasOwnProperty(m.UniqueId)) {
                                            let dbid = n[m.UniqueId];
                                            let model = e.modelObj;
                                            let code = m.MarkID;
                                            this.createCdHTMLMarkerContent(
                                                dbid,
                                                model,
                                                code,
                                                state
                                            );
                                        }
                                    });
                                    cdmodels.forEach(element=>{
                                        if (n.hasOwnProperty(element.UniqueId)) {
                                            element.dbid = n[element.UniqueId];
                                            element.model = e.modelObj;
                                            // 计算物体的位置
                                            let tmpbox3 = new Float32Array(6);
                                            element.model.getData().instanceTree.getNodeBox(element.dbid, tmpbox3);
                                            let x = (tmpbox3[0] + tmpbox3[3]) / 2;
                                            let y = (tmpbox3[1] + tmpbox3[4]) / 2;
                                            let z = (tmpbox3[2] + tmpbox3[5]) / 2;
                                            element.position = new THREE.Vector3(x, y, z);
                                        }
                                    })
                                });
                            }
                        });
                })// }));
        },
        // 根据构件的包围盒计算 周围一定距离内的测点
        getSurroundCdsByBox(box,distance){

            // 计算构件的中心点。
            let x = (box[0] + box[3]) / 2;
            let y = (box[1] + box[4]) / 2;
            let z = (box[2] + box[5]) / 2;
            var centerPosition = new THREE.Vector3(x, y, z);  
            

            //// 包围盒向外延申 distance 距离;
            var newBox = new Float32Array(6);
            newBox[0] = box[0] - distance;
            newBox[1] = box[1] - distance;
            newBox[2] = box[2] - distance;
            newBox[3] = box[3] + distance;
            newBox[4] = box[4] + distance;
            newBox[5] = box[5] + distance;

            // 筛选出在新的包围盒内的测点。
            var fitCds = [];
            cdmodels.forEach(element => {
                if(element.position){
                    if (   element.position.x > newBox[0] && element.position.y > newBox[1] && element.position.z > newBox[2] 
                        && element.position.x < newBox[3] && element.position.y < newBox[4] && element.position.z < newBox[5] ) {
                        element.distance = Math.sqrt(Math.pow(element.position.x - centerPosition.x,2) + Math.pow(element.position.y - centerPosition.y,2) + Math.pow(element.position.z - centerPosition.z,2))
                        fitCds.push(element);
                    }
                }
            });  
            var resultByType = {};
            // 根据测点类型分类。
            fitCds.forEach(element=>{
                if (cdFromServer.hasOwnProperty(element.MarkID)) {
                    var type = cdFromServer[element.MarkID].Type;
                    if (resultByType.hasOwnProperty(type)) {
                        resultByType[type].push(element);
                    }
                    else {
                        resultByType[type] = [];
                        resultByType[type].push(element);
                    }
                }
                else{
                    // 测点树中没有的测点，但是模型中有的，这些测点不计算。
                    var type = 'others';
                    if (resultByType.hasOwnProperty(type)) {
                        resultByType[type].push(element);
                    }
                    else {
                        resultByType[type] = [];
                        resultByType[type].push(element);
                    }
                }
            });
            var result = {};
            // 根据测点的类型计算距离。
            Object.keys(resultByType).forEach(key => {
                if (key !== 'others' && resultByType.hasOwnProperty(key) ) {
                    // 分类计算距离并排序
                    var points = resultByType[key];
                    var left2,left1,right1,right2; //定义四个点 和所选构件的位置关系为 left2--left1--center---right1---right2

                    points.forEach(element => {
                        // 不考虑 z 值，判断测点在所选构件的左还是右
                        if (element.position.x <= centerPosition.x && element.position.y <= centerPosition.y) {
                            //这个点在所选构件的左边

                            // 和存储的left点判断
                            if (left1) {
                                // 此点的距离比 已存储的点的距离 近
                                if (element.distance <= left1.distance) {
                                    //left1--element--center  ==> left2(原left1)--element(left1)--center
                                    left2 = left1;
                                    left1 = element;
                                } else {
                                    if (left2) {
                                        if (element.distance <= left2.distance) {
                                            //left2--element--left1--center ==> left2(element)--left1--center
                                            left2 = element;
                                        }
                                    }
                                    else{
                                        // element--left1--center ==> left2(element)--left1--center;
                                        left2 = element;
                                    }
                                }
                            } else {
                                left1 = element;
                            }
                        }else {
                            // 此点在所选构件的右边。
                            if (right1) {
                                // 此点的距离比 已存储的点的距离 近,则用此点替换right
                                if (element.distance <= right1.distance) {
                                    // center--element--right1 ==> center--right1(element)--right2(原right1)
                                    right2 = right1;
                                    right1 = element;
                                }else{
                                    // center--right1--
                                    if (right2) {
                                        if (element.distance <= right2.distance) {
                                            //center--right1--right2 ==> center--right1--element(right2)
                                            right2 = element;
                                        }

                                    }else{
                                        right2 = element;
                                    }
                                }
                            }
                            else{
                                right1 = element;
                            }
                        }
                    });

                    result[key] = [left2,left1,right1,right2];

                }
            });


            return result;
        },
        // 根据构件的中心点位置计算 周围一定距离内的测点
        getSurroundCdsByPosition(clickPosition,distance){
            var fitCds = [];
            cdmodels.forEach(element => {
                if(element.position){
                    if (Math.pow(element.position.x - clickPosition.x,2) + Math.pow(element.position.y - clickPosition.y,2) + Math.pow(element.position.z - clickPosition.z,2) < Math.pow(10,2)) {
                        fitCds.push(element);
                    }
                }
            });  
            return fitCds;
        },

        // 获取测点周围的地连墙的构件
        getSurroundElementBycdBOX(cdBox,distance){
            if (!dlqModelDbids) {
                dlqModelDbids = {};
                var instanceTree = dlqModel.getData().instanceTree;
               
                instanceTree.enumNodeChildren(instanceTree.getRootId(),dbid=>{
                    var childCount = instanceTree.getChildCount(dbid);
                    if (childCount === 0) {
                        let tempBox = new Float32Array(6);
                        instanceTree.getNodeBox(dbid,tempBox);
                        let box = new THREE.Box3(new THREE.Vector3(tempBox[0],tempBox[1],tempBox[2]),new THREE.Vector3(tempBox[3],tempBox[4],tempBox[5]));
                        tempBox = null;
                        dlqModelDbids[dbid] = box;
                    }
                },true);
            }   

            var newBox = new THREE.Box3(new THREE.Vector3(cdBox[0] - distance,cdBox[1] - distance,cdBox[2] - distance),new THREE.Vector3(cdBox[3] + distance,cdBox[4] + distance,cdBox[5] + distance));
            
            // 找出 测点附近的构件
            var resultDbids = [];
            Object.keys(dlqModelDbids).forEach(key=>{
                let elementBox = dlqModelDbids[key];
                if (elementBox.isIntersectionBox(newBox)) {
                    // 相交
                    resultDbids.push(Number.parseInt(key));
                }
            })
            return resultDbids;
        },
        changeCDColor(state,model,dbid,marker){
            var dom = document.getElementById(marker.id + "_" + marker.name); 
            switch (state) {
                case "红色报警":
                    bimEngine.setThemingColor(dbid,new THREE.Vector4(1,0,0,1),model);
                    dom.lastElementChild.lastElementChild.lastElementChild.style.backgroundImage = "url('/css/image/red.png')";
                    dom.lastElementChild.lastElementChild.lastElementChild.style.color = "#ff4848";
                    break;
                case "橙色报警":
                    bimEngine.setThemingColor(dbid,new THREE.Vector4(1,0.5,0,1),model);
                    dom.lastElementChild.lastElementChild.lastElementChild.style.backgroundImage = "url('/css/image/orange.png')";
                    dom.lastElementChild.lastElementChild.lastElementChild.style.color = "#ff872f"
                    break;
                case "黄色报警":
                    bimEngine.setThemingColor(dbid,new THREE.Vector4(1,1,0,1),model);
                    dom.lastElementChild.lastElementChild.lastElementChild.style.backgroundImage  = "url('/css/image/yellow.png')";
                    dom.lastElementChild.lastElementChild.lastElementChild.style.color = "#fbc033"
                    break;                   
                case "EarlyAlert":
                    bimEngine.setThemingColor(dbid,new THREE.Vector4(1,1,0,1),model);
                   dom.lastElementChild.lastElementChild.lastElementChild.style.backgroundImage = "url('/css/image/yellow.png')";
                   dom.lastElementChild.lastElementChild.lastElementChild.style.color = "#fbc033"
                    break;
                case "没数据":
                    bimEngine.setThemingColor(dbid,new THREE.Vector4(0.6,0.6,0.6,1),model);
                    dom.lastElementChild.lastElementChild.lastElementChild.style.backgroundImage  = "url('/css/image/gray.png')";
                    dom.lastElementChild.lastElementChild.lastElementChild.style.color = "#c3c3c3"
                    break;
                case "无":
                    bimEngine.setThemingColor(dbid,new THREE.Vector4(0.6,0.6,0.6,1),model);
                    dom.lastElementChild.lastElementChild.lastElementChild.style.backgroundImage  = "url('/css/image/gray.png')";
                    dom.lastElementChild.lastElementChild.lastElementChild.style.color = "#c3c3c3"
                    break;
                case "":
                    bimEngine.setThemingColor(dbid,new THREE.Vector4(0,1,0,1),model);
                    dom.lastElementChild.lastElementChild.lastElementChild.style.backgroundImage  = "url('/css/image/green.png')";
                    dom.lastElementChild.lastElementChild.lastElementChild.style.color = "#8cc38d"
                    break;
                default:
                    bimEngine.setThemingColor(dbid,new THREE.Vector4(0,1,0,1),model);
                    dom.lastElementChild.lastElementChild.lastElementChild.style.backgroundImage  = "url('/css/image/green.png')";
                    dom.lastElementChild.lastElementChild.lastElementChild.style.color = "#8cc38d"
                    break;
            }
        },
        getcdModels() {
            fetch("/data/cd.json", { method: "GET" })
                .then((res) => res.json())
                .then((res) => {
                    cdmodels = res;
                    modelList.forEach((e) => {
                        if (Object.keys(e.idExtenalMapping).length > 0) {
                            res.forEach((m) => {
                                if (
                                    e.idExtenalMapping.hasOwnProperty(
                                        m.UniqueId
                                    )
                                ) {
                                    let dbid = e.idExtenalMapping[m.UniqueId];
                                    let model = e.modelObj;
                                    let code = m.MarkID;
                                    this.createCdHTMLMarkerContent(
                                        dbid,
                                        model,
                                        code
                                    );
                                }
                            });
                        } else {
                            e.modelObj.getExternalIdMapping((n) => {
                                res.forEach((m) => {
                                    if (n.hasOwnProperty(m.UniqueId)) {
                                        let dbid = n[m.UniqueId];
                                        let model = e.modelObj;
                                        let code = m.MarkID;
                                        this.createCdHTMLMarkerContent(
                                            dbid,
                                            model,
                                            code
                                        );
                                    }
                                });
                            });
                        }
                    });

                  

                });
        },
        initTreeData(instanceTree, dbid, treeData, modelId) {
            var that = this;
            var childCount = instanceTree.getChildCount(dbid);
            if (childCount === 0) {
                return;
            }
            instanceTree.enumNodeChildren(dbid, function (child) {
                var node = {
                    id: modelId + "-" + child,
                    label: instanceTree.getNodeName(child),
                    children: [],
                };
                treeData.children.push(node);
                that.initTreeData(instanceTree, child, node, modelId);
            });
        },
        bimEngineCallBack() {
            var _this = this;
            bimEngine.addEventListener(
                Smart.Viewing.RENDER_FIRST_PIXEL,
                function () {
                    bimEngine.setDefaultContextMenu();
                    bimEngine.navigation.setReverseZoomDirection(true);
                    bimEngine.navigation.FIT_TO_VIEW_VERTICAL_MARGIN = 0.4;
                    bimEngine.navigation.FIT_TO_VIEW_HORIZONTAL_MARGIN  = 0.4;
                }
            );
            bimEngine.addEventListener(
                Smart.Viewing.GEOMETRY_LOADED_EVENT,
                (data) => {
                    bimEngine.autocam.goHome();
                    // this.CreateCDMarker();  添加一个示例的三维图片测点
                    this.sceneLoadedCompleted = true;
                    //this.getcdModels();
                    this.getLastCDSattus();
                    this.modelTreeDefaultChecked_New=this.modelTreeDefaultChecked
                     console.log(this.modelTreeDefaultChecked)
                },
                { once: true }
            );
            bimEngine.addEventListener(
                Smart.Viewing.AGGREGATE_SELECTION_CHANGED_EVENT,
                (data) => {
                    if (data.selections.length > 0) {
                        var dbid = data.selections[0].dbIdArray[0];
                        var model = data.selections[0].model;
                        
                        // 包含测点和地连墙等构件的模型。
                        if (model === dlqModel) {
                            let tmpbox3 = new Float32Array(6);
                            model.getData().instanceTree.getNodeBox(dbid, tmpbox3);
                            
                            // 如果点击的是 测点
                            var f =  cdmodels.filter(r=>{
                                return r.dbid === dbid
                            });

                            if(f.length > 0) {
                                // console.log(f[0]);
                                var alarIndex = AlarmStatePoint.findIndex(alar =>alar.PntName == f[0].MarkID)
                                var pointAlarmState = ''
                                if(alarIndex>-1){
                                    //测点的状态
                                    pointAlarmState = AlarmStatePoint[alarIndex].AlarmState
                                }
                                // 先清除之前的颜色
                                bimEngine.clearThemingColors(dlqModel);
                                
                                var result = this.getSurroundElementBycdBOX(tmpbox3,10);
                                //改变颜色
                                result.forEach(element => {
                                    if(pointAlarmState == '红色报警'){
                                        bimEngine.setThemingColor(element,new THREE.Vector4(1,0.28,0.28,1),dlqModel);
                                    }else if(pointAlarmState == '橙色报警'){
                                        bimEngine.setThemingColor(element,new THREE.Vector4(1,0.53,0.18,1),dlqModel);
                                    }else if(pointAlarmState == '黄色报警'){
                                        bimEngine.setThemingColor(element,new THREE.Vector4(0.98,0.75,0.2,1),dlqModel);
                                    }else if(pointAlarmState == 'EarlyAlert'){
                                        bimEngine.setThemingColor(element,new THREE.Vector4(0.98,0.75,0.2,1),dlqModel);
                                    }else if(pointAlarmState == '没数据'){
                                        bimEngine.setThemingColor(element,new THREE.Vector4(0.76,0.76,0.76,1),dlqModel);
                                    }else if(pointAlarmState == '无'){
                                        bimEngine.setThemingColor(element,new THREE.Vector4(0.76,0.76,0.76,1),dlqModel);
                                    }else if(pointAlarmState == ""){
                                        bimEngine.setThemingColor(element,new THREE.Vector4(0.55,0.76,0.55,1),dlqModel);
                                    }else{
                                        bimEngine.setThemingColor(element,new THREE.Vector4(0.55,0.76,0.55,1),dlqModel);
                                    }
                                });
                               
                            }else{
                                // 根据点击构件的包围盒去计算,非测点,
                                // 返回结果为map类型，key为测点树的类型，value为长度为4的数组，数据中前两个数据表示在所选构件的左边，后两个数据表示在所选构件的右边:（left,left,center,right,right）
                                // 如果2或3为undefined，则表明所选构件的左边或右边没有测点。
                                var fitCds = _this.getSurroundCdsByBox(tmpbox3,10);
                                console.log(fitCds);
                                if(this.pointMessageBox == true && Object.keys(fitCds).length>0){   
                                    this.mapListfitCds = fitCds                             
                                    this.interPointDialog(fitCds); 
                                }
                            }
                            
                        }                        
                    }
                }
            );
            bimEngine.addEventListener(
                Smart.Viewing.AGGREGATE_SELECTION_CHANGED_EVENT,
                function (evt) {
                    _this.modelProperties  = [];
                    if(_this.showP == false){
                        _this.elementProperties = [];
                    }else{
                        _this.showP = false
                    }
                    _this.PropertyTitle = "模型属性";
                    if (
                        _this.propertyPanelDisplay &&
                        evt.selections.length > 0
                    ) {
                        var dbids = evt.selections[0].dbIdArray;
                        var model = evt.selections[0].model;
                        model.getProperties(dbids[0], function (data) {
                            _this.modelProperties .push({
                                Key: "name",
                                Value: data.name,
                            });
                            data.properties.forEach((element) => {
                                _this.modelProperties .push({
                                    Key: element.displayName,
                                    Value: element.displayValue,
                                });
                            });
                        });
                    }
                }
            );
            bimEngine.addEventListener(
                Smart.Viewing.OBJECT_TREE_CREATED_EVENT,
                function (data) {
                    var modelName = "Model";
                    var svp = Smart.Viewing.Private;
                    for (let index = 0; index < modelList.length; index++) {
                        const element = modelList[index];
                        if (element.urn === data.model.myData.urn) {
                            modelName = element.fileName;
                            break;
                        }
                    }
                    var instanceTree = data.model.getInstanceTree();
                    var rootId = instanceTree.getRootId();
                    var modelId = data.model.id;
                    var treeData = {
                        id: modelId + "-" + rootId,
                        label: modelName,
                        children: [],
                    };
                    _this.initTreeData(instanceTree, rootId, treeData, modelId);
                    _this.modelTreeDefaultChecked.push(treeData.id);
                    console.log(_this.modelTreeDefaultChecked)
                    _this.modelTreeData.push(treeData);
                }
            );
        },
        // 树节点点击时，高亮对应的构件
        treeNodeClick(node, evt2, evt3) {
            var modelId = Number(node.id.split("-")[0]);
            var dbid = Number(node.id.split("-")[1]);
            var allModels = bimEngine.getVisibleModels();
            for (let index = 0; index < allModels.length; index++) {
                const model = allModels[index];
                if (model.id === modelId) {
                    bimEngine.select([dbid], model);
                    bimEngine.fitToView([dbid], model);
                    break;
                }
            }
        },
        // 树节点前的checkbox改变时，显示/隐藏对应的构件
        treeCheckChange(node, curNodeSelected, childNodeSelected) {
            // this.selectedTreeElementsHide(node, curNodeSelected)
            var modelId = Number(node.id.split("-")[0]);
            var dbid = Number(node.id.split("-")[1]);
            var allModels = bimEngine.getVisibleModels();
            for (let index = 0; index < allModels.length; index++) {
                const model = allModels[index];
                if (model.id === modelId) {
                    if (!curNodeSelected && !childNodeSelected) {
                        bimEngine.hide([dbid], model);
                    } else {
                        bimEngine.show([dbid], model);
                    }
                    break;
                }
            }
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        
        createCdHTMLMarkerContent(dbid, model, code, state) {
            var htmlMarker = bimEngine.getExtension("Smart.HTMLMarker");
            if (cdHtmlMarters.hasOwnProperty(code)) {
                htmlMarker.removeHtmlMarker(cdHtmlMarters[code].marker.id);
            }

            let tmpbox3 = new Float32Array(6);
            model.getData().instanceTree.getNodeBox(dbid, tmpbox3);
            let x = (tmpbox3[0] + tmpbox3[3]) / 2;
            let y = (tmpbox3[1] + tmpbox3[4]) / 2;
            let z = (tmpbox3[2] + tmpbox3[5]) / 2;
            var position = new THREE.Vector3(x, y, z);
            var backgroundImage = ""
            var color = ""
            switch (state) {
                case "红色报警":
                    // bimEngine.setThemingColor(dbid,new THREE.Vector4(1,0,0,1),model);
                    backgroundImage = "url('/css/image/red.png')";
                    color = "#ff4848";
                    break;
                case "橙色报警": 
                    backgroundImage = "url('/css/image/orange.png')";
                    color = "#ff872f"
                    break;
                case "黄色报警": 
                    backgroundImage  = "url('/css/image/yellow.png')";
                    color = "#fbc033"
                    break;                   
                case "EarlyAlert": 
                    backgroundImage = "url('/css/image/yellow.png')";
                    color = "#fbc033"
                    break;
                case "没数据": 
                    backgroundImage  = "url('/css/image/gray.png')";
                    color = "#c3c3c3"
                    break;
                case "无": 
                    backgroundImage  = "url('/css/image/gray.png')";
                    color = "#c3c3c3"
                    break;
                case "": 
                    backgroundImage  = "url('/css/image/green.png')";
                    color = "#8cc38d"
                    break;
                default: 
                    backgroundImage  = "url('/css/image/green.png')";
                    color = "#8cc38d"
                    break;
            }
            
            var html = `
                  
                      <div class="labelplan domMarker" style="z-index:10">
                        <div class="dot"></div>
                        <div class="line1"></div>
                        <div class="line2"></div>
                        <div class="divplan">
                          <div class="column" id="dot13">
                            <div class="textspan"  onclick="modelLable('${code}')" style="color:#6de4ff;font-weight: 600;background:${backgroundImage};color:${color};background-size: 100% 100%;" title="${code}">${code}</div>
                          </div>
                        </div>
                      </div>
                   
                  `;
                  
           
            // if (htmlcdmarker) {
            //     htmlMarker.removeHtmlMarker(htmlcdmarker.id); // 互斥 删除之前的htmlmarker;
            // }
            htmlcdmarker = htmlMarker.addHtmlMarker(
                null,
                code,
                null,
                html,
                position,
                Smart.Viewing.Align2D.LEFT_BOTTOM
            );
            bimEngine.impl.invalidate(true);

            cdHtmlMarters[code] = {
                marker: htmlcdmarker,
                model: model,
                dbId: dbid,
            };
        },
        CreateCDMarker() {
            var htmlMarker = bimEngine.getExtension("Smart.HTMLMarker");
            var html1 = `<div id="marker1">
                      <image  style="width:30px;height:30px;pointer-events: all;cursor: pointer;" src="/SmartViewer/res/markers/icon.png"/>
                    </div>`;
            htmlMarker.addHtmlMarker(
                null,
                "测点1",
                "marker1",
                html1,
                new THREE.Vector3(0, 11, 0),
                Smart.Viewing.Align2D.BOTTOM_MIDDLE
            );
            document.getElementById("marker1").onclick = function () {
                // document.getElementById("markid").style.display = "block"
                // document.getElementById("markid1").style.display = "block"
                // alert("测点数据");
            };
        },
        // 根据测点的编号定位模型中的测点。
        locateCDModel(code) {
            if (cdHtmlMarters.hasOwnProperty(code)) {
                let dbId = cdHtmlMarters[code].dbId;
                let model = cdHtmlMarters[code].model;
                bimEngine.select([dbId], model);
                bimEngine.fitToView([dbId], model);
            }
        },
        WeatherInfo() {
            let obj = this;
            let city = "上海";
            let cityid = "101020100";
            fetch(
                `https://www.tianqiapi.com/?version=v1&appid=68655474&appsecret=n1F4U8as&cityid=${cityid}&city=${city}&ip=&callback=`
            )
                .then((res) => res.json())
                .then((data) => {
                    let result = data.data;
                    // obj.Weather = result[0].wea + "  " + result[0].tem1 + "~" + result[0].tem2;
                    obj.Weather = result[0].tem2 + "~" + result[0].tem1;
                    obj.WeatherImg = result[0].wea_img;
                    obj.wea = result[0].wea;
                })
                .catch((err) => console.log("getWeather error"));
        },
        ShowCD() {},
        // 搜索
        search() {
            var searchPoint = this.searchPoint;
            if (searchPoint != "") {
                this.pointTreeData = this.pointTreeDataSearch.filter((n) => {
                    return n.PointName.indexOf(searchPoint) >= 0;
                });
            } else {
                this.pointTreeData = this.pointTreeDataSearch;
            }
        },
        toolBarBtnClick(type) {
            switch (type) {
                case "ModelTree":
                    if (this.modelTreeCardDisplay) {
                        this.modelTreeCardDisplay = false;
                    } else {
                        this.modelTreeCardDisplay = true;
                        this.sectionPanelDisplay = false;
                        this.measurePanelDisplay = false;
                    }
                    break;

                case "SectionSetting":
                    if (this.sectionPanelDisplay) {
                        this.sectionPanelDisplay = false;
                        this.enablePouqie = false;
                    } else {
                        this.sectionPanelDisplay = true;
                        this.modelTreeCardDisplay = false;
                        this.measurePanelDisplay = false;
                    }
                    break;
                case "MeasurePanel":
                    if (this.measurePanelDisplay) {
                        this.measurePanelDisplay = false;
                        bimEngine.getExtension("Smart.Measure").deactivate();
                        this.enableMeasure = false;
                    } else {
                        this.measurePanelDisplay = true;
                        this.modelTreeCardDisplay = false;
                        this.sectionPanelDisplay = false;
                    }
                    break;

                case "PropertyPanel":
                    if (this.propertyPanelDisplay) {
                        this.propertyPanelDisplay = false;
                        // 清空构件属性信息。
                        this.modelProperties = [];
                    } else {
                        this.propertyPanelDisplay = true;
                        this.modelProperties = [];
                        this.PropertyTitle = "模型属性";
                        // 查询构件属性，并显示
                        var select = bimEngine.getAggregateSelection();
                        if (select.length > 0) {
                            var _this = this;
                            var dbid = select[0].selection[0];
                            var model = select[0].model;
                            model.getProperties(dbid, function (data) {
                                _this.modelProperties .push({
                                        Key: "name",
                                        Value: data.name,
                                });
                                data.properties.forEach((element) => {
                                    _this.modelProperties .push({
                                        Key: element.displayName,
                                        Value: element.displayValue,
                                    });
                                });
                            });
                        }
                    }
                    break;
            }
        },

        // 剖切功能
        section(type) {
            if (!this.sceneLoadedCompleted) {
                return;
            }
            var section = bimEngine.getExtension("Smart.Section");
            switch (type) {
                case "enable":
                    if (this.enablePouqie) {
                        this.sectionMode = "x";
                        section.activate("x");
                        // nothing
                    } else {
                        section.deactivate();
                    }
                    break;
                case "无":
                    section.deactivate();
                    break;
                case "X":
                    section.activate("x");
                    break;
                case "Y":
                    section.activate("y");
                    break;
                case "Z":
                    section.activate("z");
                    break;
                case "Box":
                    section.activate("box");
                    break;
                case "mesh":
                    section.toggle();
                    break;
                default:
                    break;
            }
        },
        handleClick(tab, event) {
        },
        //统计本年的每月的变化量
        monthChange(data,month,AlertSettings){
            data = data.filter(n =>{
                return n.MonitorDate.indexOf(month) != -1;
            })
            var CurrentVariance=0;
            var TotalVariance=0;
            var DailyVariance=0;
            for(var i = 0;i<data.length;i++){
                this.PointAlarmRank.year.push(data[i].MonitorDate.substr(0,10))
                if(data.length>0){
                    if(data[i].CurrentValue){
                        this.PointAlarmRank.yearhData.CurrentVariance.push(data[i].CurrentValue)
                    }else{
                        this.PointAlarmRank.yearhData.CurrentVariance.push(0)
                    }
                    if(data[i].TotalVariance){
                        this.PointAlarmRank.yearhData.TotalVariance.push(data[i].TotalVariance)
                    }else{
                        this.PointAlarmRank.yearhData.TotalVariance.push(0)                        
                    }
                    if(data[i].DailyVariance){ 
                        this.PointAlarmRank.yearhData.DailyVariance.push(data[i].DailyVariance)
                    }else{
                        this.PointAlarmRank.yearhData.DailyVariance.push(0)
                    }

                    if(AlertSettings.TotalAlertUpLimit){ 
                        this.PointAlarmRank.yearhData.TotalAlertUpLimit.push(AlertSettings.TotalAlertUpLimit)
                    }else{
                        this.PointAlarmRank.yearhData.TotalAlertUpLimit.push(0)
                    }
                    if(AlertSettings.TotalAlertLowerLimit){ 
                        this.PointAlarmRank.yearhData.TotalAlertLowerLimit.push(AlertSettings.TotalAlertLowerLimit)
                    }else{
                        this.PointAlarmRank.yearhData.TotalAlertLowerLimit.push(0)
                    }
                }else{
                  this.PointAlarmRank.yearhData.CurrentVariance.push(0)
                  this.PointAlarmRank.yearhData.TotalVariance.push(0)
                  this.PointAlarmRank.yearhData.DailyVariance.push(0)
                  this.PointAlarmRank.yearhData.TotalAlertUpLimit.push(0)
                  this.PointAlarmRank.yearhData.TotalAlertLowerLimit.push(0)
                }
            }
        },
        // 模型树列表构件被点击
        handleNodeClick(data,type) {
            if(data.ProjectName){ //如果点击的是组，直接返回
                return
            }
            var _this = this;
            var pointName = data.PointName;
            if (pointName.indexOf("(") != -1) {
                pointName = pointName.slice(0, pointName.indexOf("("));
            }  
            this.pointNameTime = pointName  //时间筛选时候用
            this.pointNameTimeTemp = data.PointName  //时间筛选时候用
            modelList.forEach((e) => {
                var index = cdmodels.findIndex(al=>al.MarkID == pointName)                
                var  state = "";                   
                var f = AlarmStatePoint.filter(e=>{
                    return data.PointID == e.PntID
                })
                if (f.length > 0) {
                    state = f[0].AlarmState
                }

                
                if (Object.keys(e.idExtenalMapping).length > 0) {                    
                    if (index != -1 &&
                        e.idExtenalMapping.hasOwnProperty(
                            cdmodels[index].UniqueId
                        )
                    ) {
                        let dbid = e.idExtenalMapping[cdmodels[index].UniqueId];
                        let model = e.modelObj;
                        let code = cdmodels[index].MarkID;
                        this.createCdHTMLMarkerContent(
                            dbid,
                            model,
                            code,
                            state
                        );
                    }
                } else {
                    e.modelObj.getExternalIdMapping((n) => {
                        if(index ==-1){
                            this.$message({
                                type: "warning",
                                message: "测点模型尚未加载完成"
                            });
                            // break;
                        }else{
                            if (n.hasOwnProperty(cdmodels[index].UniqueId)) {
                                let dbid = n[cdmodels[index].UniqueId];
                                let model = e.modelObj;
                                let code = cdmodels[index].MarkID;
                                this.createCdHTMLMarkerContent(
                                  dbid,
                                  model,
                                  code,
                                  state
                            );
                        }

                        }
                        
                    });
                }
            });
            //判断侧斜
            console.log("data.PointName",data.PointName)
            if (data.PointName.indexOf("(") != -1) {
                var unit=data.PointName.slice(data.PointName.indexOf("("),data.PointName.length);
                if(unit.indexOf("m") != -1){
                    this.ProjectHole = true
                    this.projectHoleHeighcharts(pointName);
                }
             } 
            this.$axios({
                method: "get",
                url:
                    `External/GetPointHistoryCurve?pointName=` +
                    pointName +
                    `&startDT=2000-01-01&endDT=2220-10-10`,
                headers: {
                    rediscachekey: data.PointName+"@updateddaily",
                },
            }).then((res) => {
                //点击新视点清空数据                
                this.rightNull();
                _this.modelPoint = ""
                this.PointAlarmRankList = []

                if (res && res.length > 0) {
                    if(type != 1){                        
                      $(".heightCharStyle")[0].style.display = "block" 
                      if(cdHtmlMarters[pointName]){
                        var marker = cdHtmlMarters[pointName].marker;
                        var markerHtml = document.getElementById(marker.id + "_" + marker.name); 
                        markerHtml.lastElementChild.lastElementChild.lastElementChild.style.display == "block"
                      }else{
                        //   this.$message({
                        //     type: "warning",
                        //     message: "模型上不存在该视点信息！"
                        //   });                          
                      }
                      if(res && res.length>0){
                        _this.modelPoint = res[0].MonitorItemName;
                      }else{
                        _this.modelPoint = "";
                      }
                      if (this.propertyPanelDisplay) {
                          this.PropertyTitle = "测点属性";
                          this.elementProperties = [];
                          if (res[0].PointID) {
                              var itemP = {};
                              itemP.Key = "测点ID";
                              itemP.Value = res[0].PointID;
                              this.elementProperties.push(itemP);
                          }
                          if (res[0].PointID) {
                              var itemP = {};
                              itemP.Key = "测点名称";
                              itemP.Value = res[0].PointName;
                              this.elementProperties.push(itemP);
                          }
                          if (res[0].MonitorItemID) {
                              var itemP = {};
                              itemP.Key = "监测项目ID";
                              itemP.Value = res[0].MonitorItemID;
                              this.elementProperties.push(itemP);
                          }
                          if (res[0].MonitorItemName) {
                              var itemP = {};
                              itemP.Key = "监测项目名称";
                              itemP.Value = res[0].MonitorItemName;
                              this.elementProperties.push(itemP);
                          }
                          if (res[0].Unit) {
                              var itemP = {};
                              itemP.Key = "单位";
                              itemP.Value = res[0].Unit;
                              this.elementProperties.push(itemP);
                          }
                      }
                      cdmodels.forEach((element) => {
                          if (element.MarkID == pointName) {
                              this.showP = true
                              this.locateCDModel(pointName);
                          }
                      });
                    }
                    this.PointAlarmRankList = res
                    //处理获取的数据按时间分类，在做标轴去显示
                    if(res[0].MonitorPointDataList && res[0].MonitorPointDataList.length>0){
                        //判断是否是测斜                        
                        // if(pointName != "F01"){
                        //     if(res[0].MonitorPointDataList[0].PointDepth>0){  //PointDepth>0 说明是测斜孔
                        //         //测斜统计图
                        //         this.ProjectHole = true
                        //         this.projectHoleHeighcharts(res[0].MonitorPointDataList);
                        //     }
                        // }else{
                        //     this.ProjectHole = true
                        //     this.$nextTick(function(){
                        //         this.loadEcharts()
                        //     })
                        // }

                        var date = new Date();
                        var yearNow = date.getFullYear();
                        var monthNow = date.getMonth() + 1;
                        var dayNow = date.getDate();
                        var weekNow = date.getDay();

                        date.setDate(1);
                        var weekNowNum = date.getDay();//获取某月1号是星期几（0-6）
                        var nowDayOfWeekNum = Math.ceil((dayNow -(7-(weekNowNum==0?6:weekNowNum)))/7)//今天日期是第几周

                        if (monthNow < 10) {monthNow = "0" + monthNow;}
                        if (dayNow < 10) {dayNow = "0" + dayNow;}

                        //当前年份的数据
                        var sortDateYear = res[0].MonitorPointDataList.filter(n =>{
                            return n.MonitorDate.indexOf(yearNow+"年") != -1; 
                            //return n.MonitorDate.indexOf("2019年") != -1;
                        })
                        //当前月份的数据
                        var sortDateMonth = sortDateYear.filter(n =>{
                            return n.MonitorDate.indexOf(monthNow+"月") != -1;
                            //return n.MonitorDate.indexOf("01月") != -1;
                        })
                        //当前周的数据

                        //统计图当前年的每月数据 -->start
                        
                        for(var i=1; i<=12;i++){
                            if(date.getMonth() + 1 < i){ 
                                // break;//大于当前月份的后面直接结束不在有数据
                            }
                            var month =""
                            if(i<10){
                                month = "0"+i+"月"
                            }else{
                                month = i+"月"
                            }
                            this.monthChange(sortDateYear,month,res[0].AlertSettings);
                        }
                        //统计图当前年的每月数据 -->end

                        //统计图当前月的每日数据 -->start
                        
                        for(var sdm = 0;sdm<sortDateMonth.length;sdm++){
                            this.PointAlarmRank.month.push(sortDateMonth[sdm].MonitorDate.substr(8,3))
                            if(sortDateMonth[sdm].CurrentVariance){
                                this.PointAlarmRank.monthData.CurrentVariance.push(sortDateMonth[sdm].CurrentVariance)
                            }else{
                                this.PointAlarmRank.monthData.CurrentVariance.push(0)
                            }
                            if(sortDateMonth[sdm].TotalVariance){
                                this.PointAlarmRank.monthData.TotalVariance.push(sortDateMonth[sdm].TotalVariance)
                            }else{
                                this.PointAlarmRank.monthData.TotalVariance.push(0)
                            }                            
                            if(sortDateMonth[sdm].DailyVariance){
                                this.PointAlarmRank.monthData.DailyVariance.push(sortDateMonth[sdm].DailyVariance)
                            }else{
                                this.PointAlarmRank.monthData.DailyVariance.push(0)
                            }
                            if(res[0].AlertSettings){
                                this.PointAlarmRank.monthData.TotalAlertUpLimit.push(res[0].AlertSettings.TotalAlertUpLimit)
                            }else{
                                this.PointAlarmRank.monthData.TotalAlertUpLimit.push(0)
                            }
                            if(res[0].AlertSettings){
                                this.PointAlarmRank.monthData.TotalAlertLowerLimit.push(res[0].AlertSettings.TotalAlertLowerLimit)
                            }else{
                                this.PointAlarmRank.monthData.TotalAlertLowerLimit.push(0)
                            }
                            //找出和当前日期同一周的那一天
                            var val = sortDateMonth[sdm].MonitorDate.substr(0,4)+"-"+sortDateMonth[sdm].MonitorDate.substr(5,2)+"-"+sortDateMonth[sdm].MonitorDate.substr(8,2);
                            var ad = new Date(val); //获取某月随便一天的时间
                            var dayOfMonth = ad.getDate();//获取当前日期是某月第几号
                            var day = ad.getDay();//获取当前日期是周几()
                         
                            ad.setDate(1);
                            var dayOfWeek = ad.getDay();//获取某月1号是星期几（0-6）
                            // var theDay = Math.ceil((dayOfMonth - (7 - dayOfWeek)) / 7) + (day === 0 ? 0 : 1);

                            //获取循环的当前日期是第几周
                            var  forDate= sortDateMonth[sdm].MonitorDate.substr(8,2)
                            if(forDate.substr(0,1) == 0){
                                forDate = forDate.substr(1,1)
                            }
                            var dayOfWeekNum = Math.ceil((forDate -(7-(dayOfWeek==0?6:dayOfWeek)))/7)//现在循环日期是第几周
                            if(dayOfWeekNum == nowDayOfWeekNum){
                                this.PointAlarmRank.weekData.CurrentVariance.push(sortDateMonth[sdm].CurrentVariance)
                                this.PointAlarmRank.weekData.TotalVariance.push(sortDateMonth[sdm].TotalVariance)
                                this.PointAlarmRank.weekData.DailyVariance.push(sortDateMonth[sdm].DailyVariance)
                                this.PointAlarmRank.weekData.TotalAlertUpLimit.push(res[0].AlertSettings.TotalAlertUpLimit)
                                this.PointAlarmRank.weekData.TotalAlertLowerLimit.push(res[0].AlertSettings.TotalAlertLowerLimit)
                                var weekTemp = "";
                                switch (day) {
                                    case 1:
                                       weekTemp = "星期一";
                                        break;
                                    case 2:
                                       weekTemp = "星期二";
                                        break;
                                    case 3:
                                       weekTemp = "星期三";
                                        break;
                                    case 4:
                                        weekTemp = "星期四";
                                        break;
                                    case 5:
                                       weekTemp = "星期五";
                                        break;
                                    case 6:
                                        weekTemp = "星期六";
                                        break;
                                    case 0:
                                        weekTemp = "星期日";
                                        break;
                                }
                                this.PointAlarmRank.week.push(weekTemp)
                            }
                       }
                        //统计图当前月的每日数据 -->end

                        if(this.rightBtnStu == "本周"){
                            this.rightTable(1,this.rightBtnStu)
                        }else if(this.rightBtnStu == "本月"){
                            this.rightTable(2,this.rightBtnStu)
                        }else if(this.rightBtnStu == "本年"){
                            this.rightTable(3,this.rightBtnStu)
                        }else if(this.rightBtnStu == "筛选"){
                            this.rightTable(4,this.rightBtnStu)
                        }
                    }
                }
                
            });
        },
        //点击左下统计图点，删除所有模型上的标签并重新添加风险标签
        addRankPoint(pointRankList){
            //删除所有模型上的视点标签
            var htmlMarker = bimEngine.getExtension("Smart.HTMLMarker");
            cdmodels.forEach(el => {
                let code = el.MarkID
                if (cdHtmlMarters.hasOwnProperty(code)) {
                  htmlMarker.removeHtmlMarker(cdHtmlMarters[code].marker.id);
                }
            });
            var addPointRankList = [] //判断cd.json中有没有这个标签，将有的放到这个集合中在模型上进行创建标签
            pointRankList.forEach((pr) => {
                var cdIndex = cdmodels.findIndex(c=> c.MarkID == pr.PointName)
                if(cdIndex > -1){
                    var addPointRank = cdmodels[cdIndex]
                    addPointRank.AlarmRank = pr.AlarmRank
                    addPointRankList.push(addPointRank)
                }
            });
            console.log('addPointRankList')
            console.log(addPointRankList)
            modelList.forEach((e) => {
                if (Object.keys(e.idExtenalMapping).length > 0) {
                    addPointRankList.forEach((m) => {
                        if (
                            e.idExtenalMapping.hasOwnProperty(
                                m.UniqueId
                            )
                        ) {
                            let dbid = e.idExtenalMapping[m.UniqueId];
                            let model = e.modelObj;
                            let code = m.MarkID;
                            let state = m.AlarmRank;
                            this.createCdHTMLMarkerContent(
                                dbid,
                                model,
                                code,
                                state
                            );
                        }
                    });
                } else {
                    e.modelObj.getExternalIdMapping((n) => {
                        addPointRankList.forEach((m) => {
                            if (n.hasOwnProperty(m.UniqueId)) {
                                let dbid = n[m.UniqueId];
                                let model = e.modelObj;
                                let code = m.MarkID;
                                let state = m.AlarmRank;
                                this.createCdHTMLMarkerContent(
                                    dbid,
                                    model,
                                    code,
                                    state
                                );
                            }
                        });
                    });
                }
            });

        },
        // 视点列表视点复选框被选中
        handleCheck(data, checkedContent) {
        },
        //测点构件周围插值弹出框统计图
        interpolation(){
            chart4 = Highcharts.chart("containerInterpolation", {
                title: {
                    text: null,
                },
                chart: {
                    backgroundColor: "rgba(0,0,0,0)",
                },
                colors: [
                    "#af5cff",
                    "#e36144",
                    "#0d9cfd",
                    "#da8f7f",
                    "#76b3db",
                    "#90ed7d",
                    "#f7a35c",
                    "#8085e9",
                    "#e4d354",
                    "#8085e8",
                ],
                yAxis: {
                    title: {
                        text: null,
                    },
                    labels: {
                        formatter: function () {
                            return this.value;
                        },
                        style: {
                        },
                    },
                    gridLineDashStyle: "Dot",
                },
                xAxis: {
                    categories: [
                    ],
                    labels: {
                        formatter: function () {
                            return this.value;
                        },
                        style: {
                        },
                    },               
                    tickPositioner: function() {
    			    	var positions = [],
				        tick = 0, max = this.dataMax;
			            var increment = 1;
    			    	//当最大值大于30时，刻度线以50的倍数增加，当小于30时，刻度线以1的倍数增加
				        if (this.dataMax > 20) {
                            increment = Math.ceil(this.dataMax/20)
				        }
				        for (tick; tick <= max; tick += increment) {
				    	    positions.push(tick);
				        }
				        return positions;
    			    },
                    gridLineDashStyle: "Dot",
                },
                legend: {
                    layout: "vertical",
                    align: "right",
                    verticalAlign: "middle",
                },
                plotOptions: {
                },
                series: [
                    {
                        name: '<b style="color:#af5cff">当前变化量插值</b>',
                        data: [],
                    },
                    {
                        name: '<b style="color:#e36144">累计变化量插值</b>',
                        data: [],
                    },
                    {
                        name: '<b style="color:#0d9cfd">日变化量插值</b>',
                        data: [],
                    }
                ],
                credits: {
                    enabled: false, // 禁用版权信息
                },
                responsive: {
                    rules: [
                        {
                            condition: {
                                maxWidth: 500,
                            },
                            chartOptions: {
                                legend: {
                                    layout: "horizontal",
                                    align: "center",
                                    verticalAlign: "bottom",
                                },
                            },
                        },
                    ],
                    labels: {
                        formatter: function () {
                            return this.value;
                        },
                        style: {
                            color: "#fff",
                        },
                    },
                },
            });
        },
        //风险弹出框的统计图
        loadEcharts(){
            chart3 = Highcharts.chart('containerHole', {
            	chart: {
            		type: 'spline',
            		// inverted: true
            	},
            	title: {
            		text: '测斜曲线'
            	},
            	subtitle: {
            		text: null
                },
                colors: [
                    "#01a5ff",
                    "#f15c80",
                    "#91e8e1",
                    "#8d4653",
                    "#434348",
                    "#90ed7d",
                    "#f7a35c",
                    "#8085e9",
                    "#e4d354",
                    "#8085e8",
                ],
            	xAxis: {
            		title: {
            			enabled: true,
            			text: '变化量（mm）'
            		},
            		labels: {
            			formatter: function () {
            				return this.value ;
            			}
                    },
                    opposite : true,
                    min:-10,
                    max:10,
                    // gridLineColor: '#197F07',//纵向网格线颜色
                    gridLineWidth: 1, //纵向网格线宽度
                    // endOnTick:100,         
                    // tickPositioner: function() {
    			    // 	var positions = [],
				    //     tick = 0, max = this.dataMax;
			        //     var increment = 1;
    			    // 	//当最大值大于15时，刻度线以15的倍数增加，当小于30时，刻度线以1的倍数增加
				    //     if (this.dataMax > 15) {
                    //         increment = Math.ceil(this.dataMax/15)
				    //     }
				    //     for (tick; tick <= max; tick += increment) {
				    // 	    positions.push(tick);
				    //     }
				    //     return positions;
    			    // },
            		// maxPadding: 0.05,
            		showLastLabel: true
            	},
            	yAxis: {
            		title: {
            			text: '深度（m）'
            		},
            		labels: {
            			formatter: function () {
            				return this.value;
            			}
            		},
            		lineWidth: 2
            	},
                // gridLineColor: '#197F07',//横向网格线颜色                
                gridLineDashStyle: 'longdash',//横向网格线样式
                gridLineWidth: 1,//横向网格线宽度
            	legend: {
            		enabled: true
            	},
            	tooltip: {
            		headerFormat: '<b>{series.name}</b>:{point.x}mm<br/>',
            		pointFormat: '<b>深度</b>: {point.y}m'
            	},
            	series: [{
            		name:  '<b style="color:#01a5ff">累计变化量</b>',
            		data: []
                },{
            		name: '<b style="color:#f15c80">当前变化量</b>',
            		data: []
                }
                ],                
                credits: {
                    enabled: false, // 禁用版权信息
                },
            });
        },
        showHighcharts() {
            var _that = this
            chart1  = Highcharts.chart("pro1container", {
                chart: {
                    type: "area",
                    backgroundColor: "rgba(0,0,0,0)",
                },
                title: {
                    text: null,
                },
                // subtitle: {
                //   text: false
                // },
                colors: [
                    "#e72d2d",
                    "#e2ac37",
                    "#dad750",
                    "#8d4653",
                    "#434348",
                    "#90ed7d",
                    "#f7a35c",
                    "#8085e9",
                    "#e4d354",
                    "#8085e8",
                ],
                xAxis: {
                    title: {
            			text: null
            		},
                    categories: [],
                    crosshair: true,
                    labels: {
                        formatter: function () {
                            return this.value;
                        },
                        style: {
                            color: "#fff",
                            lineColor: "#14b7f5",
                        },
                    },
                    tickPositioner: function() {
    			    	var positions = [],
				        tick = 0, max = this.dataMax;
			            var increment = 1;
    			    	//当最大值大于30时，刻度线以50的倍数增加，当小于30时，刻度线以1的倍数增加
				        if (this.dataMax > 8) {
                            increment = Math.ceil(this.dataMax/8)
				        }
				        for (tick; tick <= max; tick += increment) {
				    	    positions.push(tick);
				        }
				        return positions;
    			    },
                    // lineColor:'#8085e8'
                },
                yAxis: {
                    min: 0,
                    title: {
                        // text: "数量",
                        text: null,
                    },
                    labels: {
                        formatter: function () {
                            return this.value;
                        },
                        style: {
                            color: "#fff",
                        },
                    },
                },
                plotLines: [
                    {
                        value: 0,
                        width: 1,
                        color: "#3a8bf9",
                    },
                ],
                tooltip: {
                    // head + 每个 point + footer 拼接成完整的 table
                    headerFormat:
                        '<span style="font-size:10px">{point.key}</span><table>',
                    pointFormat:
                        '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                        '<td style="padding:0"><b>{point.y} 个</b></td></tr>',
                    footerFormat: "</table>",
                    shared: true,
                    useHTML: true,
                },
                plotOptions: {
                    series: {
                        cursor: 'pointer',
                        events: {
                            click: function (event) {
                                _that.leftTablePointClick(event)
                            }
                        }
                    }
                },
                legend: {
                    enabled: true,
                },
                series: [
                    {
                        name: '<b style="color:#e72d2d">高风险</b>',
                        data: [],
                    },{
                        name: '<b style="color:#e2ac37">中风险</b>',
                        data: [],
                    },{
                        name: '<b style="color:#dad750">低风险</b>',
                        data: [],
                    },
                ],
                credits: {
                    enabled: false, // 禁用版权信息
                },
                responsive: {
                    rules: [
                        {
                            condition: {
                                maxWidth: 500,
                            },
                            chartOptions: {
                                legend: {
                                    layout: "horizontal",
                                    align: "center",
                                    verticalAlign: "bottom",
                                },
                            },
                        },
                    ],
                    labels: {
                        formatter: function () {
                            return this.value;
                        },
                        style: {
                            color: "#fff",
                        },
                    },
                },
            });
            chart2 = Highcharts.chart("container", {
                title: {
                    text: null,
                },
                chart: {
                    backgroundColor: "rgba(0,0,0,0)",
                },
                colors: [
                    "#af5cff",
                    "#e36144",
                    "#0d9cfd",
                    "#da8f7f",
                    "#76b3db",
                    "#90ed7d",
                    "#f7a35c",
                    "#8085e9",
                    "#e4d354",
                    "#8085e8",
                ],
                yAxis: {
                    title: {
                        text: null,
                    },
                    labels: {
                        formatter: function () {
                            return this.value;
                        },
                        style: {
                            color: "#fff",
                        },
                    },
                    gridLineDashStyle: "Dot",
                },
                xAxis: {
                    categories: [
                        "星期一",
                        "星期二",
                        "星期三",
                        "星期四",
                        "星期五",
                        "星期六",
                        "星期日",
                    ],
                    labels: {
                        formatter: function () {
                            return this.value;
                        },
                        style: {
                            color: "#fff",
                        },
                    },               
                    tickPositioner: function() {
    			    	var positions = [],
				        tick = 0, max = this.dataMax;
			            var increment = 1;
    			    	//当最大值大于30时，刻度线以50的倍数增加，当小于30时，刻度线以1的倍数增加
				        if (this.dataMax > 20) {
                            increment = Math.ceil(this.dataMax/20)
				        }
				        for (tick; tick <= max; tick += increment) {
				    	    positions.push(tick);
				        }
				        return positions;
    			    },
                    gridLineDashStyle: "Dot",
                },
                legend: {
                    layout: "vertical",
                    align: "right",
                    verticalAlign: "middle",
                },
                plotOptions: {
                    // series: {
                    //     label: {
                    //         connectorAllowed: false,
                    //     },
                    //     pointStart: 2010,
                    // },
                    // labels: {
                    //     formatter: function () {
                    //         return this.value;
                    //     },
                    //     style: {
                    //         color: "#fff",
                    //     },
                    // },
                },
                series: [
                    {
                        name: '<b style="color:#af5cff">当前变化量</b>',
                        data: [],
                    },
                    {
                        name: '<b style="color:#e36144">累计变化量</b>',
                        data: [],
                    },
                    {
                        name: '<b style="color:#0d9cfd">日变化量</b>',
                        data: [],
                    },
                    {
                        name: '<b style="color:#da8f7f">累计值报警上限</b>',
                        data: [],
                    },
                    {
                        name: '<b style="color:#76b3db">累计值报警下限</b>',
                        data: [],
                    },
                ],
                credits: {
                    enabled: false, // 禁用版权信息
                },
                responsive: {
                    rules: [
                        {
                            condition: {
                                maxWidth: 500,
                            },
                            chartOptions: {
                                legend: {
                                    layout: "horizontal",
                                    align: "center",
                                    verticalAlign: "bottom",
                                },
                            },
                        },
                    ],
                    labels: {
                        formatter: function () {
                            return this.value;
                        },
                        style: {
                            color: "#fff",
                        },
                    },
                },
            });
        },
        
        leftTable(type,time){      
           $(".cssHasL").removeClass('activeBnt');
           $("#left"+type).addClass("activeBnt")
           if(time == "本周"){

           }else if(time == "本月"){
               this.AlarmCountDate = this.timeofM();
               this.PointAlarmCount.monitorTime = this.PointAlarmCount.monthData.monthMonitorTime
               chart1.xAxis[0].setCategories(this.PointAlarmCount.month);
               chart1.series[0].setData(this.PointAlarmCount.monthData.redAlarm)
               chart1.series[1].setData(this.PointAlarmCount.monthData.orangeAlarm)
               chart1.series[2].setData(this.PointAlarmCount.monthData.yellowAlarm)
           }else if(time == "本年"){
               this.AlarmCountDate = this.timeofYear();
               this.PointAlarmCount.monitorTime = this.PointAlarmCount.monthData.yearMonitorTime
               chart1.xAxis[0].setCategories(this.PointAlarmCount.year);
               chart1.series[0].setData(this.PointAlarmCount.yearhData.redAlarm)
               chart1.series[1].setData(this.PointAlarmCount.yearhData.orangeAlarm)
               chart1.series[2].setData(this.PointAlarmCount.yearhData.yellowAlarm)
           }else if(time == "筛选"){             
               
               //将时间化成字符串进行比较
                var dateS =  this.getTimeString(new Date(this.AlarmCountDate[0]))
                var dateE = new Date(this.AlarmCountDate[1]);
                dateE.setTime(dateE.getTime() + 3600 * 1000 * 24 * 1);
                dateE = this.getTimeString(dateE)

                // PointAlarmCountList//所有的数据
                var res = this.PointAlarmCountList.filter(poAl=>{
                    return poAl.MonitorDate>=dateS && poAl.MonitorDate<dateE
                })
                res = this.sortId(res,"MonitorDate")
                this.PointAlarmCount.customFilter = []
                this.PointAlarmCount.customFilterData.customFilterMonitorTime = []
                this.PointAlarmCount.customFilterData.redAlarm = []
                this.PointAlarmCount.customFilterData.orangeAlarm = []
                this.PointAlarmCount.customFilterData.yellowAlarm = []
                for(var r=0;r<res.length;r++){
                    this.PointAlarmCount.customFilter.push(res[r].MonitorDate.substr(0,10))
                    this.PointAlarmCount.customFilterData.customFilterMonitorTime.push(res[r].MonitorTime)
                    //红色报警数量
                    var redCount = res[r].AlarmCount.filter(r =>{
                        return r.AlarmRank == "红色报警"
                    })
                    if(redCount.length>0){
                        this.PointAlarmCount.customFilterData.redAlarm.push(redCount[0].Count)
                    }else{
                        this.PointAlarmCount.customFilterData.redAlarm.push(0)
                    }
                    //橙色报警数量
                    var orangeCount = res[r].AlarmCount.filter(r =>{
                        return r.AlarmRank == "橙色报警"
                    })
                    if(orangeCount.length>0){
                        this.PointAlarmCount.customFilterData.orangeAlarm.push(orangeCount[0].Count)
                    }else{
                        this.PointAlarmCount.customFilterData.orangeAlarm.push(0)
                    }
                    //黄色报警数量
                    var yellowCount = res[r].AlarmCount.filter(r =>{
                        return r.AlarmRank == "黄色报警"
                    })
                    if(yellowCount.length>0){
                        this.PointAlarmCount.customFilterData.yellowAlarm.push(yellowCount[0].Count)
                    }else{
                        this.PointAlarmCount.customFilterData.yellowAlarm.push(0)
                    }
                } 
                this.PointAlarmCount.monitorTime = this.PointAlarmCount.customFilterData.customFilterMonitorTime
                chart1.xAxis[0].setCategories(this.PointAlarmCount.customFilter);
                chart1.series[0].setData(this.PointAlarmCount.customFilterData.redAlarm)
                chart1.series[1].setData(this.PointAlarmCount.customFilterData.orangeAlarm)
                chart1.series[2].setData(this.PointAlarmCount.customFilterData.yellowAlarm)
           }
        },
        rightTable(type,time){   
            this.rightBtnStu = time   
           $(".cssHasR").removeClass('activeBnt');
           $("#right"+type).addClass("activeBnt")
           if(time == "本周"){
               this.AlarmRankDate = this.timeofweek();
             chart2.xAxis[0].setCategories(this.PointAlarmRank.week);
             chart2.series[0].setData(this.PointAlarmRank.weekData.CurrentVariance);
             chart2.series[1].setData(this.PointAlarmRank.weekData.TotalVariance);
             chart2.series[2].setData(this.PointAlarmRank.weekData.DailyVariance);
             chart2.series[3].setData(this.PointAlarmRank.weekData.TotalAlertUpLimit);
             chart2.series[4].setData(this.PointAlarmRank.weekData.TotalAlertLowerLimit);
           }else if(time == "本月"){
               this.AlarmRankDate = this.timeofM();
              chart2.xAxis[0].setCategories(this.PointAlarmRank.month);
              chart2.series[0].setData(this.PointAlarmRank.monthData.CurrentVariance);
              chart2.series[1].setData(this.PointAlarmRank.monthData.TotalVariance);
              chart2.series[2].setData(this.PointAlarmRank.monthData.DailyVariance);
              chart2.series[3].setData(this.PointAlarmRank.monthData.TotalAlertUpLimit);
              chart2.series[4].setData(this.PointAlarmRank.monthData.TotalAlertLowerLimit);
           }else if(time == "本年"){
               this.AlarmRankDate = this.timeofYear();
               chart2.xAxis[0].setCategories(this.PointAlarmRank.year);
               chart2.series[0].setData(this.PointAlarmRank.yearhData.CurrentVariance);
               chart2.series[1].setData(this.PointAlarmRank.yearhData.TotalVariance);
               chart2.series[2].setData(this.PointAlarmRank.yearhData.DailyVariance);
               chart2.series[3].setData(this.PointAlarmRank.yearhData.TotalAlertUpLimit);
               chart2.series[4].setData(this.PointAlarmRank.yearhData.TotalAlertLowerLimit);
           }else if(time == "筛选"){
                this.PointAlarmRank.customFilter = []
                this.PointAlarmRank.customFilterData.CurrentVariance = []
                this.PointAlarmRank.customFilterData.TotalVariance = []
                this.PointAlarmRank.customFilterData.DailyVariance = []
                this.PointAlarmRank.customFilterData.TotalAlertUpLimit = []
                this.PointAlarmRank.customFilterData.TotalAlertLowerLimit = []

                var dateS = this.getTimeString(new Date(this.AlarmRankDate[0]));
                var dateE = new Date(this.AlarmRankDate[1]);
                dateE.setTime(dateE.getTime() + 3600 * 1000 * 24 * 1);
                dateE  = this.getTimeString(dateE);
                var res = this.PointAlarmRankList
                if(res.length>0){
                    if(res[0].MonitorPointDataList && res[0].MonitorPointDataList.length>0){
                        var resTemp = this.sortId(res[0].MonitorPointDataList,"MonitorDate")
                        resTemp = resTemp.filter(pRan =>{
                            return pRan.MonitorDate>=dateS && pRan.MonitorDate<dateE
                        })
                        for(var sdm = 0;sdm<resTemp.length;sdm++){
                            this.PointAlarmRank.customFilter.push(resTemp[sdm].MonitorDate.substr(0,10))
                            if(resTemp[sdm].CurrentVariance){
                                this.PointAlarmRank.customFilterData.CurrentVariance.push(resTemp[sdm].CurrentVariance)
                            }else{
                                this.PointAlarmRank.customFilterData.CurrentVariance.push(0)
                            }
                            if(resTemp[sdm].TotalVariance){
                                this.PointAlarmRank.customFilterData.TotalVariance.push(resTemp[sdm].TotalVariance)
                            }else{
                                this.PointAlarmRank.customFilterData.TotalVariance.push(0)
                            }                            
                            if(resTemp[sdm].DailyVariance){
                                this.PointAlarmRank.customFilterData.DailyVariance.push(resTemp[sdm].DailyVariance)
                            }else{
                                this.PointAlarmRank.customFilterData.DailyVariance.push(0)
                            }
                            if(res[0].AlertSettings){
                                this.PointAlarmRank.customFilterData.TotalAlertUpLimit.push(res[0].AlertSettings.TotalAlertUpLimit)
                            }else{
                                this.PointAlarmRank.customFilterData.TotalAlertUpLimit.push(0)
                            }
                            if(res[0].AlertSettings){
                                this.PointAlarmRank.customFilterData.TotalAlertLowerLimit.push(res[0].AlertSettings.TotalAlertLowerLimit)
                            }else{
                                this.PointAlarmRank.customFilterData.TotalAlertLowerLimit.push(0)
                            }
                        }

                    }
                }
                chart2.xAxis[0].setCategories(this.PointAlarmRank.customFilter);
                chart2.series[0].setData(this.PointAlarmRank.customFilterData.CurrentVariance);
                chart2.series[1].setData(this.PointAlarmRank.customFilterData.TotalVariance);
                chart2.series[2].setData(this.PointAlarmRank.customFilterData.DailyVariance);
                chart2.series[3].setData(this.PointAlarmRank.customFilterData.TotalAlertUpLimit);
                chart2.series[4].setData(this.PointAlarmRank.customFilterData.TotalAlertLowerLimit);
           }
        },
        measureEnabled(){
            if (this.enableMeasure) {
                bimEngine.getExtension("Smart.Measure").activate('distance');
            }else{
                bimEngine.getExtension("Smart.Measure").deactivate();
            }
        },
        resetMeasure(){
            bimEngine.getExtension("Smart.Measure").measureTool.deleteMeasurements();
        },
        measure(){
            switch (this.measureType) {
                case 'angle':
                    bimEngine.getExtension("Smart.Measure").activate('angle');
                    break;
                case 'distance':
                    bimEngine.getExtension("Smart.Measure").activate('distance');
                    break;
                default:

                    break;
            }
        },
        //打开监控日志弹出框
        GetProjectDailys(){
            this.ProjectDailys=true
        },
        //下载监控日志
        downLoadFile(row){
            window.open(row.FileUrl)
        },
        //风险弹出框的显隐
        rankDialog(){
            this.ProjectAlarm = !this.ProjectAlarm
        },
        //左侧坐标轴点的点击事件
        leftTablePointClick(e){
            var monitorTimeP = this.PointAlarmCount.monitorTime[e.point.index]
            this.$axios({
                method: "get",
                url: "External/GetProjectTimeAlarms?monitorTime="+monitorTimeP,
                headers: {
                    rediscachekey: monitorTimeP,
                },
            }).then((res) => {
                this.ProjectAlarm = true
                this.alertCountTable = res
                this.optionsCount.serviceData = res;

                var pointMap = {}
                var pointRankList = [] //供新建风险测点使用
                for(var i=0;i<res.length;i++)
                {
                    var pointName = res[i].PointName;
                    if (pointName.indexOf("(") != -1) {
                        pointName = pointName.slice(0, pointName.indexOf("("));
                    }  
                    pointMap[pointName] = pointName;
                    var pointRank = {}
                    pointRank.PointName = pointName;
                    pointRank.AlarmRank = res[i].AlarmRank;
                    pointRankList.push(pointRank);

                }
                this.addRankPoint(pointRankList);
                this.pointViewList(pointMap);
                this.PaginationComponentCount = () =>
                    import("@/components/PaginationAsync");
            })
        },
        //传入测点名称数组
        pointViewList(pointMap){
            var dbids = [];
            cdmodels.forEach(element => {
                if (pointMap.hasOwnProperty(element.MarkID)) {
                    dbids.push(element.dbid);
                }
            });
            bimEngine.fitToView(dbids,cdmodels[0].model);
        },
        closeAlarm(){
            this.ProjectAlarm = false
        },
        //关闭监控日志弹出框
        closeDailys(){
            this.ProjectDailys=false
        },
        getTimeString(date){
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            month = month<10?"0"+month:month
            var day = date.getDate();
            day = day<10?"0"+day:day;
            return year+"年"+month+"月"+day+"日"+" "+"00:00:00"
        },
        //查询监控日志
        serchdailys(){
            if(this.dailysTime){
                let dateS = new Date(this.dailysTime[0]);
                let dateE = new Date(this.dailysTime[1]);
                dateE.setTime(dateE.getTime() + 3600 * 1000 * 24 * 1);
                var strdateS = this.getTimeString(dateS)
                var strdateE = this.getTimeString(dateE)
                this.options.serviceData = this.DailysListTemp.filter(da =>{
                    if(da.UploadDate){
                        return da.UploadDate>strdateS & da.UploadDate<strdateE
                    }
                })                
                this.PaginationComponent = () => import("@/components/PaginationAsync");
            }else{
                this.options.serviceData = this.DailysListTemp
                this.PaginationComponent = () => import("@/components/PaginationAsync");
            }
        },
        closeHole(){
            this.ProjectHole = false
        },
        open(){
        },
        //测斜统计图赋值
        projectHoleHeighcharts(pointName){
            this.$nextTick(function(){
                 this.loadEcharts()
                 chart3.series[0].setData([]);
                 chart3.series[1].setData([]);
            })
            console.log("pointName",pointName)
            this.$axios({
                method: "get",
                url:
                    `External/GetBoreHoleCurve?HoleName=` + pointName,
                headers: {
                    rediscachekey: pointName+"@updateddaily",
                },
            }).then((res) => {
                var MonitorPointDataList = []
                if(res && res.length>0){
                   MonitorPointDataList =  res[0].BoreHoleDataList
                }else{
                    return
                }
                console.log(res)

                // var MonitorPointDataList = res
                this.$nextTick(function(){
                    this.loadEcharts()
                    var Variance = []
                    var Variance1 = []
                    for(var i =0; i<MonitorPointDataList.length;i++){
                        //当前变化量
                        var mo = []
                        mo[0] = MonitorPointDataList[i].CurrentVariance
                        mo[1] = -MonitorPointDataList[i].PointDepth
    
                        //累计变化量
                        var mo1 = []
                        mo1[0] = MonitorPointDataList[i].TotalVariance
                        mo1[1] = -MonitorPointDataList[i].PointDepth
    
                        Variance.push(mo)
                        Variance1.push(mo1)
                    }
                    
                    var allDateXandY = Variance1.concat(Variance)
                    var allDataX = []
                    allDateXandY.forEach(x=>{
                        allDataX.push(x[0])
                    })
                    var maxVal = Math.max.apply(null, allDataX);//最大值
                    var mixVal = Math.min.apply(null, allDataX);//最小值
                    if(maxVal>0.001 & mixVal<-0.001){                        
                        var maxValShow = Math.ceil(maxVal+10);//坐标轴显示的最大值
                        var mixValShow = Math.floor(mixVal-10);//坐标轴显示的最小值
                        if(Math.abs(maxValShow)>Math.abs(mixValShow)){
                            chart3.xAxis[0].setExtremes(-maxValShow, maxValShow,true,true);
                        }else{
                            maxValShow = Math.abs(mixValShow);
                            chart3.xAxis[0].setExtremes(mixValShow, maxValShow,true,true);
                        }
                    }
                    chart3.series[0].setData(Variance1);
                    chart3.series[1].setData(Variance);
                })  
            })
        },
        //提取时间的年月日
    timeCut(date){
      var strTime =''
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月      
      month = month < 10 ? "0" + month : month; // 如果只有一位，则前面补零
      let day = date.getDate(); // 日
      day = day < 10 ? "0" + day : day; // 如果只有一位，则前面补零
      strTime = `${year}-${month}-${day}`;
      return strTime
    },
    timeChangeLeft(){
        this.leftTable(4,"筛选");
    },
    timeChangeRight(){
        this.rightTable(4,"筛选");
    },
    colsePoint(){
        this.Tonull();
        this.pointInterpolation = false
    },
    timeChangeInter(){
        this.interTable(4,"筛选");        
    },

    interTable(type,time){
        this.interBtnStu = time   
        if(type !="all"){ //不是切换组来改变数据
           $(".cssHasD").removeClass('activeBntInter');
           $("#inter"+type).addClass("activeBntInter")
        }
        if(time == "本月"){
            this.interDate = this.timeofM();
        }else if(time == "本年"){
            this.interDate = this.timeofYear();
        }
        else if(time == "筛选"){
            // this.interDate = this.timeofYear();
        }
        var dateS = this.getTimeString(new Date(this.interDate[0]));
        var dateE = new Date(this.interDate[1]);
        dateE.setTime(dateE.getTime() + 3600 * 1000 * 24 * 1);
        dateE  = this.getTimeString(dateE);
        
        var handleData = this.currentInterDate
        var mapList = this.mapListfitCds
        var key = this.showInterDetail
        if(handleData[1] !="暂无" && handleData[2] !="暂无"){
            var p1Mon = handleData[1].MonitorPointDataList
            if(p1Mon && p1Mon.length>0){  
                    var p2Mon = handleData[2].MonitorPointDataList
                    if(p2Mon && p2Mon.length>0){
                        var resTemp1 = this.sortId(handleData[1].MonitorPointDataList,"MonitorDate")
                        resTemp1 = resTemp1.filter(pRan =>{
                            return pRan.MonitorDate>=dateS && pRan.MonitorDate<dateE
                        })
                        var resTemp2 = this.sortId(handleData[2].MonitorPointDataList,"MonitorDate")
                        resTemp2 = resTemp2.filter(pRan =>{
                            return pRan.MonitorDate>=dateS && pRan.MonitorDate<dateE
                        })
                        this.interDataList.customFilter = []
                        this.interDataList.customFilterData.CurrentVariance = []
                        this.interDataList.customFilterData.TotalVariance = []
                        this.interDataList.customFilterData.DailyVariance = []
                        for(var sdm = 0;sdm<resTemp1.length;sdm++){
                            this.interDataList.customFilter.push(resTemp1[sdm].MonitorDate.substr(0,10))
                            
                            if(resTemp1[sdm].CurrentVariance!=undefined && resTemp2[sdm].CurrentVariance!=undefined){
                                var x = (((resTemp2[sdm].CurrentVariance)*(mapList[key][1].distance)) + ((resTemp1[sdm].CurrentVariance)*(mapList[key][2].distance)))/((mapList[key][1].distance)+(mapList[key][2].distance))
                                x = Math.abs(x)
                               x = Number(parseFloat(x).toFixed(2));
                                this.interDataList.customFilterData.CurrentVariance.push(x)
                            }else{
                                this.interDataList.customFilterData.CurrentVariance.push(0)
                            }
                            if(resTemp1[sdm].TotalVariance!=undefined && resTemp2[sdm].TotalVariance!=undefined){
                                var x = ((resTemp2[sdm].TotalVariance*mapList[key][1].distance) + (resTemp1[sdm].TotalVariance*mapList[key][2].distance))/(mapList[key][1].distance+mapList[key][2].distance)
                                x = Math.abs(x)
                                x = Number(parseFloat(x).toFixed(2));
                                this.interDataList.customFilterData.TotalVariance.push(x)
                            }else{
                                this.interDataList.customFilterData.TotalVariance.push(0)
                            }                            
                            if(resTemp1[sdm].DailyVariance!=undefined && resTemp2[sdm].DailyVariance!=undefined){
                                var x = ((resTemp2[sdm].DailyVariance*mapList[key][1].distance) + (resTemp1[sdm].DailyVariance*mapList[key][2].distance))/(mapList[key][1].distance+mapList[key][2].distance)
                                x = Math.abs(x)
                                x = Number(parseFloat(x).toFixed(2));
                                this.interDataList.customFilterData.DailyVariance.push(x)
                            }else{
                                this.interDataList.customFilterData.DailyVariance.push(0)
                            }
                        }
                    }else{
                        var resTemp0 = this.sortId(handleData[1].MonitorPointDataList,"MonitorDate")
                        resTemp0 = resTemp0.filter(pRan =>{
                            return pRan.MonitorDate>=dateS && pRan.MonitorDate<dateE
                        })
                        if(resTemp0){
                            this.onlyOneData(resTemp0);
                        }else{
                            this.Tonull();                         
                        }   
                    }
            }else{  //第一个报警数据无值
                var p2Mon = handleData[2].MonitorPointDataList
                if(p2Mon && p2Mon.length>0){
                    var resTemp0 = this.sortId(handleData[2].MonitorPointDataList,"MonitorDate")
                    resTemp0 = resTemp0.filter(pRan =>{
                        return pRan.MonitorDate>=dateS && pRan.MonitorDate<dateE
                    })
                    if(resTemp0){
                        this.onlyOneData(resTemp0);
                    }else{
                        this.Tonull();                         
                    }                                      
                }else{
                    this.Tonull();                           
                }
            }

        }else if(handleData[1] !="暂无" && handleData[2] =="暂无"){
            if(handleData[1].MonitorPointDataList && handleData[1].MonitorPointDataList.length>0){
                var resTemp0 = this.sortId(handleData[1].MonitorPointDataList,"MonitorDate")
                resTemp0 = resTemp0.filter(pRan =>{
                    return pRan.MonitorDate>=dateS && pRan.MonitorDate<dateE
                })
                if(resTemp0){
                    this.onlyOneData(resTemp0);
                }else{
                    this.Tonull();                           
                }
            }else{
                this.Tonull();                           
            }

        }else if(handleData[1] =="暂无" && handleData[2] !="暂无"){
            if(handleData[2].MonitorPointDataList && handleData[2].MonitorPointDataList.length>0){
                var resTemp0 = this.sortId(handleData[2].MonitorPointDataList,"MonitorDate")
                resTemp0 = resTemp0.filter(pRan =>{
                    return pRan.MonitorDate>=dateS && pRan.MonitorDate<dateE
                })
                if(resTemp0){
                    this.onlyOneData(resTemp0);
                }else{
                    this.Tonull();   

                }
            }else{
                this.Tonull();                           
            }
        }
        chart4.xAxis[0].setCategories(this.interDataList.customFilter);
        chart4.series[0].setData(this.interDataList.customFilterData.CurrentVariance);
        chart4.series[1].setData(this.interDataList.customFilterData.TotalVariance);
        chart4.series[2].setData(this.interDataList.customFilterData.DailyVariance);
    },
    
    openPoint(){
        this.pointMessageBox = !this.pointMessageBox
    },  
    //空值
    Tonull(){
        this.interDataList.customFilter = []
        this.interDataList.customFilterData.CurrentVariance = []
        this.interDataList.customFilterData.TotalVariance = []
        this.interDataList.customFilterData.DailyVariance = []

        var seriesList = chart4.series; //获得图表的所有序列
        //通过for循环删除序列数据
        if(seriesList){
            for(var i = 0;i<seriesList.length;i++)
            {
                 chart4.series[i].setData([]);
            }
        }        
        var categoriesList = chart4.categories; //获得图表的所有X轴
        if(categoriesList){
            //通过for循环删除X轴数据
            for(var i = 0;i<categoriesList .length;i++)
            {
                 chart4.categories[i].remove();
            }

        }
        
    },
    //右下统计图掷空
    rightNull(){
        this.PointAlarmRank.yearhData.CurrentVariance=[]
        this.PointAlarmRank.yearhData.TotalVariance=[]
        this.PointAlarmRank.yearhData.DailyVariance=[]
        this.PointAlarmRank.yearhData.TotalAlertUpLimit=[]
        this.PointAlarmRank.yearhData.TotalAlertLowerLimit=[]
        this.PointAlarmRank.monthData.CurrentVariance=[]
        this.PointAlarmRank.monthData.TotalVariance=[]
        this.PointAlarmRank.monthData.DailyVariance=[] 
        this.PointAlarmRank.monthData.TotalAlertUpLimit=[]
        this.PointAlarmRank.monthData.TotalAlertLowerLimit=[]                       
        this.PointAlarmRank.weekData.CurrentVariance=[]
        this.PointAlarmRank.weekData.TotalVariance=[]
        this.PointAlarmRank.weekData.DailyVariance=[]
        this.PointAlarmRank.weekData.TotalAlertUpLimit=[]
        this.PointAlarmRank.weekData.TotalAlertLowerLimit=[]
        this.PointAlarmRank.customFilterData.CurrentVariance=[]
        this.PointAlarmRank.customFilterData.TotalVariance=[]
        this.PointAlarmRank.customFilterData.DailyVariance=[]
        this.PointAlarmRank.customFilterData.TotalAlertUpLimit=[]
        this.PointAlarmRank.customFilterData.TotalAlertLowerLimit=[]
        this.PointAlarmRank.month=[];
        this.PointAlarmRank.week=[]
        this.PointAlarmRank.year = []
        this.PointAlarmRank.customFilter = []

        var seriesList = chart2.series; //获得图表的所有序列
        //通过for循环删除序列数据
        if(seriesList){
            for(var i = 0;i<seriesList.length;i++)
            {
                 chart2.series[i].setData([]);
            }
        }        
        var categoriesList = chart2.categories; //获得图表的所有X轴
        if(categoriesList){
            //通过for循环删除X轴数据
            for(var i = 0;i<categoriesList .length;i++)
            {
                 chart2.categories[i].remove();
            }

        }
    },
    //只有一个值时
    onlyOneData(resTemp0){
        this.interDataList.customFilter = []
        this.interDataList.customFilterData.CurrentVariance = []
        this.interDataList.customFilterData.TotalVariance = []
        this.interDataList.customFilterData.DailyVariance = []
        for(var sdm = 0;sdm<resTemp0.length;sdm++){
            this.interDataList.customFilter.push(resTemp0[sdm].MonitorDate.substr(0,10))
            if(resTemp0[sdm].CurrentVariance){
                this.interDataList.customFilterData.CurrentVariance.push(resTemp0[sdm].CurrentVariance)
            }else{
                this.interDataList.customFilterData.CurrentVariance.push(0)
            }
            if(resTemp0[sdm].TotalVariance){
                this.interDataList.customFilterData.TotalVariance.push(resTemp0[sdm].TotalVariance)
            }else{
                this.interDataList.customFilterData.TotalVariance.push(0)
            }                            
            if(resTemp0[sdm].DailyVariance){
                this.interDataList.customFilterData.DailyVariance.push(resTemp0[sdm].DailyVariance)
            }else{
                this.interDataList.customFilterData.DailyVariance.push(0)
            }
        }
    },
    clickZuName(zul){
        var zuInfo = this.zuList.filter(z => z.zuName == zul)
        var zu = zuInfo[0]
        this.pointarr = zu.zuarr
        this.showInterDetail = zu.zuName
        this.currentInterDate = zu.zuPointarr
        this.interTable("all",this.interBtnStu);
    },
    interPointDialog(mapList){  
        this.pointInterpolation = true; 
        this.$nextTick(function(){           
            this.interpolation();
        })
        this.zuList = []
        this.currentInterDate = []
        this.pointarr = [] 
        this.showInterDetail = ""
        Object.keys(mapList).forEach((key,index) => {
            if(index==0){
                this.showInterDetail = key
            }
            var newInter = {}
            newInter.zuName = key  //循环的组名
            newInter.zuarr = mapList[key]  //循环的组的数组数据（左0，左1，右2，右3）
            newInter.zuPointarr = [] //测点的数据
            console.log(mapList[key]) 
            var interPoint = mapList[key] //循环出来的左右测点数组
            if(interPoint[1]==undefined && interPoint[2] !=undefined){ //如果左边第二个为undefined，那么左边都为undefined，并且右边有一个不为空
                this.$axios({  
                    method: "get",
                    url:
                        `External/GetPointHistoryCurve?pointName=` +
                        interPoint[2].MarkID +
                        `&startDT=2000-01-01&endDT=2220-10-10`,
                    headers: {
                        rediscachekey: interPoint[2].MarkID+"@updateddaily",
                    }
                }).then(p0 =>{
                    newInter.zuPointarr.push("暂无") //左0
                    newInter.zuPointarr.push("暂无") //左1
                    newInter.zuPointarr.push("暂无") //右2
                    newInter.zuPointarr.push("暂无") //右3
                    this.zuList.push(newInter)
                    this.$nextTick(function(){
                        this.interpolation()
                        var dateS = this.getTimeString(new Date(this.interDate[0]));
                        var dateE = new Date(this.interDate[1]);
                        dateE.setTime(dateE.getTime() + 3600 * 1000 * 24 * 1);
                        dateE  = this.getTimeString(dateE);
                        if(p0[0] && p0.length>0){
                            this.zuList[index].zuPointarr[2] = p0[0]  //右2
                            var p0Mon = p0[0].MonitorPointDataList
                            if(p0Mon && p0Mon.length>0){  //第一个报警数据有值
                                var resTemp0 = this.sortId(p0[0].MonitorPointDataList,"MonitorDate")
                                resTemp0 = resTemp0.filter(pRan =>{
                                    return pRan.MonitorDate>=dateS && pRan.MonitorDate<dateE
                                })
                                if(index==0){
                                    this.onlyOneData(resTemp0);
                                } 
                            }
                        }
                        if(index==0){
                            this.currentInterDate = this.zuList[0].zuPointarr  
                            this.pointarr = this.zuList[0].zuarr                     
                            chart4.xAxis[0].setCategories(this.interDataList.customFilter);
                            chart4.series[0].setData(this.interDataList.customFilterData.CurrentVariance);
                            chart4.series[1].setData(this.interDataList.customFilterData.TotalVariance);
                            chart4.series[2].setData(this.interDataList.customFilterData.DailyVariance);
                            
                        }
                        console.log(this.zuList) 

                    })
                })
            
            }else if(interPoint[2]==undefined && interPoint[1]!=undefined){ //如果右边第一个为undefined，那么右边都为undefined，并且左边有一个不为空
                this.$axios({  
                    method: "get",
                    url:
                        `External/GetPointHistoryCurve?pointName=` +
                        interPoint[1].MarkID +
                        `&startDT=2000-01-01&endDT=2220-10-10`,
                    headers: {
                        rediscachekey: interPoint[1].MarkID+"@updateddaily",
                    }
                }).then(p0 =>{
                    newInter.zuPointarr.push("暂无") //左0
                    newInter.zuPointarr.push("暂无") //左1
                    newInter.zuPointarr.push("暂无") //右2
                    newInter.zuPointarr.push("暂无") //右3
                    this.zuList.push(newInter)
                        this.$nextTick(function(){
                            this.interpolation()
                        var dateS = this.getTimeString(new Date(this.interDate[0]));
                        var dateE = new Date(this.interDate[1]);
                        dateE.setTime(dateE.getTime() + 3600 * 1000 * 24 * 1);
                        dateE  = this.getTimeString(dateE);
                        if(p0[0] && p0.length>0){
                                this.zuList[index].zuPointarr[1] = p0[0]  //左1
                                var p0Mon = p0[0].MonitorPointDataList
                                if(p0Mon && p0Mon.length>0){  //第一个报警数据有值
                                    var resTemp0 = this.sortId(p0[0].MonitorPointDataList,"MonitorDate")
                                    resTemp0 = resTemp0.filter(pRan =>{
                                        return pRan.MonitorDate>=dateS && pRan.MonitorDate<dateE
                                    })
                                    
                                    if(index==0){
                                        this.onlyOneData(resTemp0);
                                    } 
                                }

                        }
                        if(index==0){
                            this.currentInterDate = this.zuList[0].zuPointarr    
                            this.pointarr = this.zuList[0].zuarr                                                      
                            chart4.xAxis[0].setCategories(this.interDataList.customFilter);
                            chart4.series[0].setData(this.interDataList.customFilterData.CurrentVariance);
                            chart4.series[1].setData(this.interDataList.customFilterData.TotalVariance);
                            chart4.series[2].setData(this.interDataList.customFilterData.DailyVariance);
                        }
                        console.log(this.zuList) 

                    })
                })
            
            }else if(interPoint[1]!=undefined && interPoint[2] !=undefined){ //如果左边第二个不为undefined，并且右边第二个不为undefined
                this.$axios.all([
                    this.$axios({  
                        method: "get",
                        url:
                            `External/GetPointHistoryCurve?pointName=` +
                            interPoint[1].MarkID +
                            `&startDT=2000-01-01&endDT=2220-10-10`,
                        headers: {
                            rediscachekey: interPoint[1].MarkID+"@updateddaily",
                        }
                    }),
                    this.$axios({  
                        method: "get",
                        url:
                            `External/GetPointHistoryCurve?pointName=` +
                            interPoint[2].MarkID +
                            `&startDT=2000-01-01&endDT=2220-10-10`,
                        headers: {
                            rediscachekey: interPoint[2].MarkID+"@updateddaily",
                        },
                    })
                    ]).then(
                        this.$axios.spread((p1,p2) => {
                            newInter.zuPointarr.push("暂无") //左0
                            newInter.zuPointarr.push("暂无") //左1
                            newInter.zuPointarr.push("暂无") //右2
                            newInter.zuPointarr.push("暂无") //右3
                            this.zuList.push(newInter)
                            this.$nextTick(function(){
                                this.interpolation()
                            var dateS = this.getTimeString(new Date(this.interDate[0]));
                            var dateE = new Date(this.interDate[1]);
                            dateE.setTime(dateE.getTime() + 3600 * 1000 * 24 * 1);
                            dateE  = this.getTimeString(dateE);
                            if(p1[0] && p1.length>0){//第一个报警数据有值
                                this.zuList[index].zuPointarr[1] = p1[0]  //左1
                                var p1Mon = p1[0].MonitorPointDataList
                                if(p1Mon && p1Mon.length>0){  
                                    if(p2[0] && p2.length>0){ //第二个报警数据有值
                                        this.zuList[index].zuPointarr[2] = p2[0]  //左1
                                        var p2Mon = p2[0].MonitorPointDataList
                                        if(p2Mon && p2Mon.length>0){
                                            var resTemp1 = this.sortId(p1[0].MonitorPointDataList,"MonitorDate")
                                            resTemp1 = resTemp1.filter(pRan =>{
                                                return pRan.MonitorDate>=dateS && pRan.MonitorDate<dateE
                                            })
                                            var resTemp2 = this.sortId(p2[0].MonitorPointDataList,"MonitorDate")
                                            resTemp2 = resTemp2.filter(pRan =>{
                                                return pRan.MonitorDate>=dateS && pRan.MonitorDate<dateE
                                            })
                                            this.interDataList.customFilter = []
                                            this.interDataList.customFilterData.CurrentVariance = []
                                            this.interDataList.customFilterData.TotalVariance = []
                                            this.interDataList.customFilterData.DailyVariance = []
                                            for(var sdm = 0;sdm<resTemp1.length;sdm++){
                                                this.interDataList.customFilter.push(resTemp1[sdm].MonitorDate.substr(0,10))
                                                
                                                if(resTemp1[sdm].CurrentVariance!=undefined && resTemp2[sdm].CurrentVariance!=undefined){
                                                    var x = (((resTemp2[sdm].CurrentVariance)*(mapList[key][1].distance)) + ((resTemp1[sdm].CurrentVariance)*(mapList[key][2].distance)))/((mapList[key][1].distance)+(mapList[key][2].distance))
                                                    x = Math.abs(x)
                                                   x = Number(parseFloat(x).toFixed(2));
                                                    this.interDataList.customFilterData.CurrentVariance.push(x)
                                                }else{
                                                    this.interDataList.customFilterData.CurrentVariance.push(0)
                                                }
                                                if(resTemp1[sdm].TotalVariance!=undefined && resTemp2[sdm].TotalVariance!=undefined){
                                                    var x = ((resTemp2[sdm].TotalVariance*mapList[key][1].distance) + (resTemp1[sdm].TotalVariance*mapList[key][2].distance))/(mapList[key][1].distance+mapList[key][2].distance)
                                                    x = Math.abs(x)
                                                    x = Number(parseFloat(x).toFixed(2));
                                                    this.interDataList.customFilterData.TotalVariance.push(x)
                                                }else{
                                                    this.interDataList.customFilterData.TotalVariance.push(0)
                                                }                            
                                                if(resTemp1[sdm].DailyVariance!=undefined && resTemp2[sdm].DailyVariance!=undefined){
                                                    var x = ((resTemp2[sdm].DailyVariance*mapList[key][1].distance) + (resTemp1[sdm].DailyVariance*mapList[key][2].distance))/(mapList[key][1].distance+mapList[key][2].distance)
                                                    x = Math.abs(x)
                                                    x = Number(parseFloat(x).toFixed(2));
                                                    this.interDataList.customFilterData.DailyVariance.push(x)
                                                }else{
                                                    this.interDataList.customFilterData.DailyVariance.push(0)
                                                }
                                            }
                                        }
                                    }else{ //第二个报警数据无值
                                        var resTemp0 = this.sortId(p1[0].MonitorPointDataList,"MonitorDate")
                                        resTemp0 = resTemp0.filter(pRan =>{
                                            return pRan.MonitorDate>=dateS && pRan.MonitorDate<dateE
                                        })
                                        if(index==0){
                                            this.onlyOneData(resTemp0);
                                        }
                                    }
                                }else{  //第一个报警数据无值
                                    if(p2[0] && p2.length>0){ //第二个报警数据有值
                                        this.zuList[index].zuPointarr[2] = p2[0]  //左1
                                        var p2Mon = p2[0].MonitorPointDataList
                                        var p2Mon = p2[0].MonitorPointDataList
                                        if(p2Mon && p2Mon.length>0){
                                            var resTemp0 = this.sortId(p2[0].MonitorPointDataList,"MonitorDate")
                                            resTemp0 = resTemp0.filter(pRan =>{
                                                return pRan.MonitorDate>=dateS && pRan.MonitorDate<dateE
                                            })
                                            if(index==0){
                                                this.onlyOneData(resTemp0);
                                            }                                           
                                        }
                                    }
                                }
                            }
                            if(index==0){
                                this.currentInterDate = this.zuList[0].zuPointarr
                                this.pointarr = this.zuList[0].zuarr      
                                chart4.xAxis[0].setCategories(this.interDataList.customFilter);
                                chart4.series[0].setData(this.interDataList.customFilterData.CurrentVariance);
                                chart4.series[1].setData(this.interDataList.customFilterData.TotalVariance);
                                chart4.series[2].setData(this.interDataList.customFilterData.DailyVariance);
                            }
                            console.log(this.zuList) 
                        })
                      })
                    )            
            }
        })        
    },
    },
    beforeDestroy() {
        if(bimEngine){
            bimEngine.finish();
            bimEngine = null;
            modelList = [];
        }
    },
};
</script>

<style scoped>
.bimAll {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    background: url(../../assets/mark/bg.png);
}
#viewport {
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.header {
    position: absolute;
    width: 100%;
    height: 115px;
    z-index: 11;
    background: url(../../assets/mark/titleFont_bg.png);
    background-size: 100% 100%;
    /* opacity:0.8; */
}
.model {
    top: 132px;
    left: 40px;
    position: absolute;
    width: 348px;
    height: 577px;
    z-index: 11;
    opacity: 0.8;
    background: url(../../assets/mark/left_bg.png);
}
.modelproperty {
    right: 30px;
    left: unset;
}
.model >>> .el-card {
    border: none;
    background-color: transparent;
    color: #ffffff;
}
.model >>> .el-card__header {
    border: none;
}
.model >>> .el-tabs__nav-wrap::after {
    background-color: transparent;
}
.model >>> .el-tabs__header {
    padding-left: 23px;
}
.model >>> .el-tabs__item:hover {
    color: #ffffff;
}
.model >>> .el-tabs__item {
    color: #01ccff;
    font-size: 15px;
    font-weight: 600;
    padding: 0 32px;
}
.model >>> .el-tabs__item.is-active {
    color: #ffffff;
}
.model >>> .el-card__body {
    padding-top: 0px;
}
.TreeLeftBtn {
    float: left;
    width: 126px;
    height: 26px;
    cursor: pointer;
    line-height: 28px;
    background: url(../../assets/mark/buttonleft.png);
    margin-left: 20px;
}
.TreeRightBtn {
    float: right;
    margin-right: 20px;
    width: 122px;
    height: 26px;
    line-height: 28px;
    background: url(../../assets/mark/buttonright.png);
    cursor: pointer;
}
.TreeLeftBtn1 {
    float: left;
    width: 268px;
    height: 26px;
    cursor: pointer;
    line-height: 28px;
    margin-left: 20px;
    margin-top: 12px;
    margin-bottom: 15px;
}
.TreeLeftBtn1 >>> .el-input__inner {
    height: 28px;
    background-color: #24253b;
    color: #ffffff;
    border: 1px solid #01ccff;
}
.TreeRightBtn1 {
    float: right;
    margin-right: 20px;
    margin-top: 12px;
    width: 40px;
    height: 26px;
    line-height: 28px;
    background: url(../../assets/mark/buttonright.png);
    cursor: pointer;
}
/deep/ #propertyPanel .cell {
    color: #fff;
}
/deep/ #propertyPanel .el-table tr {
    background-color: #102039;
}
.tree-content {
    height: 390px;
    width: 308px;
    overflow-x: hidden;
    overflow-y: auto;
}
.tree-content >>> .el-tree {
    background: transparent;
    color: #ffffff;
}
.tree-content >>> .el-tree-node__content:hover {
    background-color: #242546;
}
.tree-content >>> .el-tree-node:focus > .el-tree-node__content {
    background-color: #242546;
}
.modeltree >>> .el-tree {
    background: transparent;
    color: #ffffff;
}
.modeltree >>> .el-tree-node__content:hover {
    background-color: #242546;
}
.modeltree >>> .el-tree-node:focus > .el-tree-node__content {
    background-color: #242546;
}
.propertyTitle {
    line-height: 35px;
    background: url(../../assets/mark/propertybg.png);
    border: 1px solid #ffffff;
    border-bottom: none;
}

.toolbars {
    text-align: center;
    z-index: 7;
    /*margin-left: 45%;
     bottom: 260px;
    position: absolute; */
}
.heightCharStyle {
    text-align: left;
    z-index: 7;
    margin-left: 40px;
    /* position: absolute; */
    background: peachpuff;
    width: 100%;
    height: 238px;
    background: url(../../assets/mark/bottombg.png);
    background-size: 100% 100%;
}
.heightChar {
    position: absolute;
    height: 200px;
    background: palegreen;
}
.heightChartop {
    color: #ffffff;
    margin-left: 30px;
    padding-top: 20px;
}
.heightCharleft {
    width: 750px;
    height: 200px;
    margin-left: 30px;
    float: left;
}
.heightCharStyle >>> .el-button {
    padding: 5px 10px;
    background: #014790;
    color: #ffffff;
    border: none;
}
.heightCharDialog >>>.el-button {
    padding: 10px 15px;
    background: #58a2f1;
    color: #ffffff;
    border: none;
}
.heightCharDialog>>>.el-input__inner{
    background-color: unset;
    height:40px;
    margin-right: 10px;
}
.avatarwea {
    width: 34px;
    /* height: 28px;
     border-radius: 50%; */
    vertical-align: middle;
    display: inline-block;
}
.LRpoint{
    padding: 10px;
    margin-left: 14px;
    font-size: 16px;
    border-radius: 11px;
    border: 1px solid #C0C4CC;
}
.activeBnt {
    background: #3a8bf9 !important;
}
.activeBntInter {
    background: #255ead !important;
}
.heightCharright {
    float: right;
    width: 1000px;
    height: 200px;
    margin-right: 20px;
}
#toolbar .el-button--primary {
    background-color: #444444;
    border-radius: 10px;
}

.heightCharleft>>>.el-date-editor .el-range-input{
    background-color: unset;
    color: #fff;
}
.heightCharleft>>>.el-input__inner{
    background-color: unset;
    height:34px;
    margin-right: 10px;
    width: 260px;
}
.heightCharleft>>>.el-date-editor .el-range-separator{
    color: #fff;
}
.heightCharright>>>.el-date-editor .el-range-input{
    background-color: unset;
    color: #fff;
}
.heightCharright>>>.el-input__inner{
    background-color: unset;
    height:34px;
    margin-right: 10px;
    width: 260px;
}
.heightCharright>>>.el-date-editor .el-range-separator{
    color: #fff;
}
.rankClass>>>.el-dialog{
  width: 1600px !important;
}
.interClass>>>.el-dialog{
  width: 1500px !important;
}
.rankClass >>>.el-table th>.cell{
    font-size: 14px;
    font-weight: 100;
}
.interZu{
    width: 320px; 
    text-align: left;
    border-radius: 5px;
    font-size: 18px;  
    margin-left: 80px;
}
.interZuTitle{
    cursor: pointer;
    background: #79b1ec;
    padding: 10px;
    border-radius: 5px;
}

.rankDialogClass{
    text-align: left;
    font-size: 18px;
    margin-bottom: 10px;
}
/* 设置滚动条的样式 */
::-webkit-scrollbar {
    height: 3px;
    width: 3px;
    background-color: #ededed;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #405970;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #d6d4d4;
}
</style>
<style>
.el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: transparent;
}
</style>
